/**
 * Refresh with:
 *   pay exec scripts/localization/sync_timezone_messages.rb && \
 *     pay js:exec prettier --write frontend/sail-next/packages/intl/src/public/timezoneMessages/timezoneMessages.ts
 */
import message from '@sail/intl/public/message/message';

export const timezoneMessages: Record<string, ReturnType<typeof message>> = {
  'Africa/Abidjan': message({
    id: 'sail_timezones.timezone.Africa_Abidjan',
    description: 'Display name for the Africa/Abidjan timezone',
    defaultMessage: 'Africa - Abidjan',
  }),
  'Africa/Accra': message({
    id: 'sail_timezones.timezone.Africa_Accra',
    description: 'Display name for the Africa/Accra timezone',
    defaultMessage: 'Africa - Accra',
  }),
  'Africa/Addis_Ababa': message({
    id: 'sail_timezones.timezone.Africa_Addis_Ababa',
    description: 'Display name for the Africa/Addis_Ababa timezone',
    defaultMessage: 'Africa - Addis Ababa',
  }),
  'Africa/Algiers': message({
    id: 'sail_timezones.timezone.Africa_Algiers',
    description: 'Display name for the Africa/Algiers timezone',
    defaultMessage: 'Africa - Algiers',
  }),
  'Africa/Asmara': message({
    id: 'sail_timezones.timezone.Africa_Asmara',
    description: 'Display name for the Africa/Asmara timezone',
    defaultMessage: 'Africa - Asmara',
  }),
  'Africa/Asmera': message({
    id: 'sail_timezones.timezone.Africa_Asmera',
    description: 'Display name for the Africa/Asmera timezone',
    defaultMessage: 'Africa - Asmera',
  }),
  'Africa/Bamako': message({
    id: 'sail_timezones.timezone.Africa_Bamako',
    description: 'Display name for the Africa/Bamako timezone',
    defaultMessage: 'Africa - Bamako',
  }),
  'Africa/Bangui': message({
    id: 'sail_timezones.timezone.Africa_Bangui',
    description: 'Display name for the Africa/Bangui timezone',
    defaultMessage: 'Africa - Bangui',
  }),
  'Africa/Banjul': message({
    id: 'sail_timezones.timezone.Africa_Banjul',
    description: 'Display name for the Africa/Banjul timezone',
    defaultMessage: 'Africa - Banjul',
  }),
  'Africa/Bissau': message({
    id: 'sail_timezones.timezone.Africa_Bissau',
    description: 'Display name for the Africa/Bissau timezone',
    defaultMessage: 'Africa - Bissau',
  }),
  'Africa/Blantyre': message({
    id: 'sail_timezones.timezone.Africa_Blantyre',
    description: 'Display name for the Africa/Blantyre timezone',
    defaultMessage: 'Africa - Blantyre',
  }),
  'Africa/Brazzaville': message({
    id: 'sail_timezones.timezone.Africa_Brazzaville',
    description: 'Display name for the Africa/Brazzaville timezone',
    defaultMessage: 'Africa - Brazzaville',
  }),
  'Africa/Bujumbura': message({
    id: 'sail_timezones.timezone.Africa_Bujumbura',
    description: 'Display name for the Africa/Bujumbura timezone',
    defaultMessage: 'Africa - Bujumbura',
  }),
  'Africa/Cairo': message({
    id: 'sail_timezones.timezone.Africa_Cairo',
    description: 'Display name for the Africa/Cairo timezone',
    defaultMessage: 'Africa - Cairo',
  }),
  'Africa/Casablanca': message({
    id: 'sail_timezones.timezone.Africa_Casablanca',
    description: 'Display name for the Africa/Casablanca timezone',
    defaultMessage: 'Africa - Casablanca',
  }),
  'Africa/Ceuta': message({
    id: 'sail_timezones.timezone.Africa_Ceuta',
    description: 'Display name for the Africa/Ceuta timezone',
    defaultMessage: 'Africa - Ceuta',
  }),
  'Africa/Conakry': message({
    id: 'sail_timezones.timezone.Africa_Conakry',
    description: 'Display name for the Africa/Conakry timezone',
    defaultMessage: 'Africa - Conakry',
  }),
  'Africa/Dakar': message({
    id: 'sail_timezones.timezone.Africa_Dakar',
    description: 'Display name for the Africa/Dakar timezone',
    defaultMessage: 'Africa - Dakar',
  }),
  'Africa/Dar_es_Salaam': message({
    id: 'sail_timezones.timezone.Africa_Dar_es_Salaam',
    description: 'Display name for the Africa/Dar_es_Salaam timezone',
    defaultMessage: 'Africa - Dar es Salaam',
  }),
  'Africa/Djibouti': message({
    id: 'sail_timezones.timezone.Africa_Djibouti',
    description: 'Display name for the Africa/Djibouti timezone',
    defaultMessage: 'Africa - Djibouti',
  }),
  'Africa/Douala': message({
    id: 'sail_timezones.timezone.Africa_Douala',
    description: 'Display name for the Africa/Douala timezone',
    defaultMessage: 'Africa - Douala',
  }),
  'Africa/El_Aaiun': message({
    id: 'sail_timezones.timezone.Africa_El_Aaiun',
    description: 'Display name for the Africa/El_Aaiun timezone',
    defaultMessage: 'Africa - El Aaiun',
  }),
  'Africa/Freetown': message({
    id: 'sail_timezones.timezone.Africa_Freetown',
    description: 'Display name for the Africa/Freetown timezone',
    defaultMessage: 'Africa - Freetown',
  }),
  'Africa/Gaborone': message({
    id: 'sail_timezones.timezone.Africa_Gaborone',
    description: 'Display name for the Africa/Gaborone timezone',
    defaultMessage: 'Africa - Gaborone',
  }),
  'Africa/Harare': message({
    id: 'sail_timezones.timezone.Africa_Harare',
    description: 'Display name for the Africa/Harare timezone',
    defaultMessage: 'Africa - Harare',
  }),
  'Africa/Johannesburg': message({
    id: 'sail_timezones.timezone.Africa_Johannesburg',
    description: 'Display name for the Africa/Johannesburg timezone',
    defaultMessage: 'Africa - Johannesburg',
  }),
  'Africa/Juba': message({
    id: 'sail_timezones.timezone.Africa_Juba',
    description: 'Display name for the Africa/Juba timezone',
    defaultMessage: 'Africa - Juba',
  }),
  'Africa/Kampala': message({
    id: 'sail_timezones.timezone.Africa_Kampala',
    description: 'Display name for the Africa/Kampala timezone',
    defaultMessage: 'Africa - Kampala',
  }),
  'Africa/Khartoum': message({
    id: 'sail_timezones.timezone.Africa_Khartoum',
    description: 'Display name for the Africa/Khartoum timezone',
    defaultMessage: 'Africa - Khartoum',
  }),
  'Africa/Kigali': message({
    id: 'sail_timezones.timezone.Africa_Kigali',
    description: 'Display name for the Africa/Kigali timezone',
    defaultMessage: 'Africa - Kigali',
  }),
  'Africa/Kinshasa': message({
    id: 'sail_timezones.timezone.Africa_Kinshasa',
    description: 'Display name for the Africa/Kinshasa timezone',
    defaultMessage: 'Africa - Kinshasa',
  }),
  'Africa/Lagos': message({
    id: 'sail_timezones.timezone.Africa_Lagos',
    description: 'Display name for the Africa/Lagos timezone',
    defaultMessage: 'Africa - Lagos',
  }),
  'Africa/Libreville': message({
    id: 'sail_timezones.timezone.Africa_Libreville',
    description: 'Display name for the Africa/Libreville timezone',
    defaultMessage: 'Africa - Libreville',
  }),
  'Africa/Lome': message({
    id: 'sail_timezones.timezone.Africa_Lome',
    description: 'Display name for the Africa/Lome timezone',
    defaultMessage: 'Africa - Lome',
  }),
  'Africa/Luanda': message({
    id: 'sail_timezones.timezone.Africa_Luanda',
    description: 'Display name for the Africa/Luanda timezone',
    defaultMessage: 'Africa - Luanda',
  }),
  'Africa/Lubumbashi': message({
    id: 'sail_timezones.timezone.Africa_Lubumbashi',
    description: 'Display name for the Africa/Lubumbashi timezone',
    defaultMessage: 'Africa - Lubumbashi',
  }),
  'Africa/Lusaka': message({
    id: 'sail_timezones.timezone.Africa_Lusaka',
    description: 'Display name for the Africa/Lusaka timezone',
    defaultMessage: 'Africa - Lusaka',
  }),
  'Africa/Malabo': message({
    id: 'sail_timezones.timezone.Africa_Malabo',
    description: 'Display name for the Africa/Malabo timezone',
    defaultMessage: 'Africa - Malabo',
  }),
  'Africa/Maputo': message({
    id: 'sail_timezones.timezone.Africa_Maputo',
    description: 'Display name for the Africa/Maputo timezone',
    defaultMessage: 'Africa - Maputo',
  }),
  'Africa/Maseru': message({
    id: 'sail_timezones.timezone.Africa_Maseru',
    description: 'Display name for the Africa/Maseru timezone',
    defaultMessage: 'Africa - Maseru',
  }),
  'Africa/Mbabane': message({
    id: 'sail_timezones.timezone.Africa_Mbabane',
    description: 'Display name for the Africa/Mbabane timezone',
    defaultMessage: 'Africa - Mbabane',
  }),
  'Africa/Mogadishu': message({
    id: 'sail_timezones.timezone.Africa_Mogadishu',
    description: 'Display name for the Africa/Mogadishu timezone',
    defaultMessage: 'Africa - Mogadishu',
  }),
  'Africa/Monrovia': message({
    id: 'sail_timezones.timezone.Africa_Monrovia',
    description: 'Display name for the Africa/Monrovia timezone',
    defaultMessage: 'Africa - Monrovia',
  }),
  'Africa/Nairobi': message({
    id: 'sail_timezones.timezone.Africa_Nairobi',
    description: 'Display name for the Africa/Nairobi timezone',
    defaultMessage: 'Africa - Nairobi',
  }),
  'Africa/Ndjamena': message({
    id: 'sail_timezones.timezone.Africa_Ndjamena',
    description: 'Display name for the Africa/Ndjamena timezone',
    defaultMessage: 'Africa - Ndjamena',
  }),
  'Africa/Niamey': message({
    id: 'sail_timezones.timezone.Africa_Niamey',
    description: 'Display name for the Africa/Niamey timezone',
    defaultMessage: 'Africa - Niamey',
  }),
  'Africa/Nouakchott': message({
    id: 'sail_timezones.timezone.Africa_Nouakchott',
    description: 'Display name for the Africa/Nouakchott timezone',
    defaultMessage: 'Africa - Nouakchott',
  }),
  'Africa/Ouagadougou': message({
    id: 'sail_timezones.timezone.Africa_Ouagadougou',
    description: 'Display name for the Africa/Ouagadougou timezone',
    defaultMessage: 'Africa - Ouagadougou',
  }),
  'Africa/Porto-Novo': message({
    id: 'sail_timezones.timezone.Africa_Porto-Novo',
    description: 'Display name for the Africa/Porto-Novo timezone',
    defaultMessage: 'Africa - Porto-Novo',
  }),
  'Africa/Sao_Tome': message({
    id: 'sail_timezones.timezone.Africa_Sao_Tome',
    description: 'Display name for the Africa/Sao_Tome timezone',
    defaultMessage: 'Africa - Sao Tome',
  }),
  'Africa/Timbuktu': message({
    id: 'sail_timezones.timezone.Africa_Timbuktu',
    description: 'Display name for the Africa/Timbuktu timezone',
    defaultMessage: 'Africa - Timbuktu',
  }),
  'Africa/Tripoli': message({
    id: 'sail_timezones.timezone.Africa_Tripoli',
    description: 'Display name for the Africa/Tripoli timezone',
    defaultMessage: 'Africa - Tripoli',
  }),
  'Africa/Tunis': message({
    id: 'sail_timezones.timezone.Africa_Tunis',
    description: 'Display name for the Africa/Tunis timezone',
    defaultMessage: 'Africa - Tunis',
  }),
  'Africa/Windhoek': message({
    id: 'sail_timezones.timezone.Africa_Windhoek',
    description: 'Display name for the Africa/Windhoek timezone',
    defaultMessage: 'Africa - Windhoek',
  }),
  'America/Adak': message({
    id: 'sail_timezones.timezone.America_Adak',
    description: 'Display name for the America/Adak timezone',
    defaultMessage: 'America - Adak',
  }),
  'America/Anchorage': message({
    id: 'sail_timezones.timezone.America_Anchorage',
    description: 'Display name for the America/Anchorage timezone',
    defaultMessage: 'America - Anchorage',
  }),
  'America/Anguilla': message({
    id: 'sail_timezones.timezone.America_Anguilla',
    description: 'Display name for the America/Anguilla timezone',
    defaultMessage: 'America - Anguilla',
  }),
  'America/Antigua': message({
    id: 'sail_timezones.timezone.America_Antigua',
    description: 'Display name for the America/Antigua timezone',
    defaultMessage: 'America - Antigua',
  }),
  'America/Araguaina': message({
    id: 'sail_timezones.timezone.America_Araguaina',
    description: 'Display name for the America/Araguaina timezone',
    defaultMessage: 'America - Araguaina',
  }),
  'America/Argentina/Buenos_Aires': message({
    id: 'sail_timezones.timezone.America_Argentina_Buenos_Aires',
    description: 'Display name for the America/Argentina/Buenos_Aires timezone',
    defaultMessage: 'America - Buenos Aires, Argentina',
  }),
  'America/Argentina/Catamarca': message({
    id: 'sail_timezones.timezone.America_Argentina_Catamarca',
    description: 'Display name for the America/Argentina/Catamarca timezone',
    defaultMessage: 'America - Catamarca, Argentina',
  }),
  'America/Argentina/ComodRivadavia': message({
    id: 'sail_timezones.timezone.America_Argentina_ComodRivadavia',
    description:
      'Display name for the America/Argentina/ComodRivadavia timezone',
    defaultMessage: 'America - Comod Rivadavia, Argentina',
  }),
  'America/Argentina/Cordoba': message({
    id: 'sail_timezones.timezone.America_Argentina_Cordoba',
    description: 'Display name for the America/Argentina/Cordoba timezone',
    defaultMessage: 'America - Cordoba, Argentina',
  }),
  'America/Argentina/Jujuy': message({
    id: 'sail_timezones.timezone.America_Argentina_Jujuy',
    description: 'Display name for the America/Argentina/Jujuy timezone',
    defaultMessage: 'America - Jujuy, Argentina',
  }),
  'America/Argentina/La_Rioja': message({
    id: 'sail_timezones.timezone.America_Argentina_La_Rioja',
    description: 'Display name for the America/Argentina/La_Rioja timezone',
    defaultMessage: 'America - La Rioja, Argentina',
  }),
  'America/Argentina/Mendoza': message({
    id: 'sail_timezones.timezone.America_Argentina_Mendoza',
    description: 'Display name for the America/Argentina/Mendoza timezone',
    defaultMessage: 'America - Mendoza, Argentina',
  }),
  'America/Argentina/Rio_Gallegos': message({
    id: 'sail_timezones.timezone.America_Argentina_Rio_Gallegos',
    description: 'Display name for the America/Argentina/Rio_Gallegos timezone',
    defaultMessage: 'America - Rio Gallegos, Argentina',
  }),
  'America/Argentina/Salta': message({
    id: 'sail_timezones.timezone.America_Argentina_Salta',
    description: 'Display name for the America/Argentina/Salta timezone',
    defaultMessage: 'America - Salta, Argentina',
  }),
  'America/Argentina/San_Juan': message({
    id: 'sail_timezones.timezone.America_Argentina_San_Juan',
    description: 'Display name for the America/Argentina/San_Juan timezone',
    defaultMessage: 'America - San Juan, Argentina',
  }),
  'America/Argentina/San_Luis': message({
    id: 'sail_timezones.timezone.America_Argentina_San_Luis',
    description: 'Display name for the America/Argentina/San_Luis timezone',
    defaultMessage: 'America - San Luis, Argentina',
  }),
  'America/Argentina/Tucuman': message({
    id: 'sail_timezones.timezone.America_Argentina_Tucuman',
    description: 'Display name for the America/Argentina/Tucuman timezone',
    defaultMessage: 'America - Tucuman, Argentina',
  }),
  'America/Argentina/Ushuaia': message({
    id: 'sail_timezones.timezone.America_Argentina_Ushuaia',
    description: 'Display name for the America/Argentina/Ushuaia timezone',
    defaultMessage: 'America - Ushuaia, Argentina',
  }),
  'America/Aruba': message({
    id: 'sail_timezones.timezone.America_Aruba',
    description: 'Display name for the America/Aruba timezone',
    defaultMessage: 'America - Aruba',
  }),
  'America/Asuncion': message({
    id: 'sail_timezones.timezone.America_Asuncion',
    description: 'Display name for the America/Asuncion timezone',
    defaultMessage: 'America - Asuncion',
  }),
  'America/Atikokan': message({
    id: 'sail_timezones.timezone.America_Atikokan',
    description: 'Display name for the America/Atikokan timezone',
    defaultMessage: 'America - Atikokan',
  }),
  'America/Atka': message({
    id: 'sail_timezones.timezone.America_Atka',
    description: 'Display name for the America/Atka timezone',
    defaultMessage: 'America - Atka',
  }),
  'America/Bahia': message({
    id: 'sail_timezones.timezone.America_Bahia',
    description: 'Display name for the America/Bahia timezone',
    defaultMessage: 'America - Bahia',
  }),
  'America/Bahia_Banderas': message({
    id: 'sail_timezones.timezone.America_Bahia_Banderas',
    description: 'Display name for the America/Bahia_Banderas timezone',
    defaultMessage: 'America - Bahia Banderas',
  }),
  'America/Barbados': message({
    id: 'sail_timezones.timezone.America_Barbados',
    description: 'Display name for the America/Barbados timezone',
    defaultMessage: 'America - Barbados',
  }),
  'America/Belem': message({
    id: 'sail_timezones.timezone.America_Belem',
    description: 'Display name for the America/Belem timezone',
    defaultMessage: 'America - Belem',
  }),
  'America/Belize': message({
    id: 'sail_timezones.timezone.America_Belize',
    description: 'Display name for the America/Belize timezone',
    defaultMessage: 'America - Belize',
  }),
  'America/Blanc-Sablon': message({
    id: 'sail_timezones.timezone.America_Blanc-Sablon',
    description: 'Display name for the America/Blanc-Sablon timezone',
    defaultMessage: 'America - Blanc-Sablon',
  }),
  'America/Boa_Vista': message({
    id: 'sail_timezones.timezone.America_Boa_Vista',
    description: 'Display name for the America/Boa_Vista timezone',
    defaultMessage: 'America - Boa Vista',
  }),
  'America/Bogota': message({
    id: 'sail_timezones.timezone.America_Bogota',
    description: 'Display name for the America/Bogota timezone',
    defaultMessage: 'America - Bogota',
  }),
  'America/Boise': message({
    id: 'sail_timezones.timezone.America_Boise',
    description: 'Display name for the America/Boise timezone',
    defaultMessage: 'America - Boise',
  }),
  'America/Buenos_Aires': message({
    id: 'sail_timezones.timezone.America_Buenos_Aires',
    description: 'Display name for the America/Buenos_Aires timezone',
    defaultMessage: 'America - Buenos Aires',
  }),
  'America/Cambridge_Bay': message({
    id: 'sail_timezones.timezone.America_Cambridge_Bay',
    description: 'Display name for the America/Cambridge_Bay timezone',
    defaultMessage: 'America - Cambridge Bay',
  }),
  'America/Campo_Grande': message({
    id: 'sail_timezones.timezone.America_Campo_Grande',
    description: 'Display name for the America/Campo_Grande timezone',
    defaultMessage: 'America - Campo Grande',
  }),
  'America/Cancun': message({
    id: 'sail_timezones.timezone.America_Cancun',
    description: 'Display name for the America/Cancun timezone',
    defaultMessage: 'America - Cancun',
  }),
  'America/Caracas': message({
    id: 'sail_timezones.timezone.America_Caracas',
    description: 'Display name for the America/Caracas timezone',
    defaultMessage: 'America - Caracas',
  }),
  'America/Catamarca': message({
    id: 'sail_timezones.timezone.America_Catamarca',
    description: 'Display name for the America/Catamarca timezone',
    defaultMessage: 'America - Catamarca',
  }),
  'America/Cayenne': message({
    id: 'sail_timezones.timezone.America_Cayenne',
    description: 'Display name for the America/Cayenne timezone',
    defaultMessage: 'America - Cayenne',
  }),
  'America/Cayman': message({
    id: 'sail_timezones.timezone.America_Cayman',
    description: 'Display name for the America/Cayman timezone',
    defaultMessage: 'America - Cayman',
  }),
  'America/Chicago': message({
    id: 'sail_timezones.timezone.America_Chicago',
    description: 'Display name for the America/Chicago timezone',
    defaultMessage: 'America - Chicago',
  }),
  'America/Chihuahua': message({
    id: 'sail_timezones.timezone.America_Chihuahua',
    description: 'Display name for the America/Chihuahua timezone',
    defaultMessage: 'America - Chihuahua',
  }),
  'America/Coral_Harbour': message({
    id: 'sail_timezones.timezone.America_Coral_Harbour',
    description: 'Display name for the America/Coral_Harbour timezone',
    defaultMessage: 'America - Coral Harbour',
  }),
  'America/Cordoba': message({
    id: 'sail_timezones.timezone.America_Cordoba',
    description: 'Display name for the America/Cordoba timezone',
    defaultMessage: 'America - Cordoba',
  }),
  'America/Costa_Rica': message({
    id: 'sail_timezones.timezone.America_Costa_Rica',
    description: 'Display name for the America/Costa_Rica timezone',
    defaultMessage: 'America - Costa Rica',
  }),
  'America/Coyhaique': message({
    id: 'sail_timezones.timezone.America_Coyhaique',
    description: 'Display name for the America/Coyhaique timezone',
    defaultMessage: 'America - Coyhaique',
  }),
  'America/Creston': message({
    id: 'sail_timezones.timezone.America_Creston',
    description: 'Display name for the America/Creston timezone',
    defaultMessage: 'America - Creston',
  }),
  'America/Cuiaba': message({
    id: 'sail_timezones.timezone.America_Cuiaba',
    description: 'Display name for the America/Cuiaba timezone',
    defaultMessage: 'America - Cuiaba',
  }),
  'America/Curacao': message({
    id: 'sail_timezones.timezone.America_Curacao',
    description: 'Display name for the America/Curacao timezone',
    defaultMessage: 'America - Curacao',
  }),
  'America/Danmarkshavn': message({
    id: 'sail_timezones.timezone.America_Danmarkshavn',
    description: 'Display name for the America/Danmarkshavn timezone',
    defaultMessage: 'America - Danmarkshavn',
  }),
  'America/Dawson': message({
    id: 'sail_timezones.timezone.America_Dawson',
    description: 'Display name for the America/Dawson timezone',
    defaultMessage: 'America - Dawson',
  }),
  'America/Dawson_Creek': message({
    id: 'sail_timezones.timezone.America_Dawson_Creek',
    description: 'Display name for the America/Dawson_Creek timezone',
    defaultMessage: 'America - Dawson Creek',
  }),
  'America/Denver': message({
    id: 'sail_timezones.timezone.America_Denver',
    description: 'Display name for the America/Denver timezone',
    defaultMessage: 'America - Denver',
  }),
  'America/Detroit': message({
    id: 'sail_timezones.timezone.America_Detroit',
    description: 'Display name for the America/Detroit timezone',
    defaultMessage: 'America - Detroit',
  }),
  'America/Dominica': message({
    id: 'sail_timezones.timezone.America_Dominica',
    description: 'Display name for the America/Dominica timezone',
    defaultMessage: 'America - Dominica',
  }),
  'America/Edmonton': message({
    id: 'sail_timezones.timezone.America_Edmonton',
    description: 'Display name for the America/Edmonton timezone',
    defaultMessage: 'America - Edmonton',
  }),
  'America/Eirunepe': message({
    id: 'sail_timezones.timezone.America_Eirunepe',
    description: 'Display name for the America/Eirunepe timezone',
    defaultMessage: 'America - Eirunepe',
  }),
  'America/El_Salvador': message({
    id: 'sail_timezones.timezone.America_El_Salvador',
    description: 'Display name for the America/El_Salvador timezone',
    defaultMessage: 'America - El Salvador',
  }),
  'America/Ensenada': message({
    id: 'sail_timezones.timezone.America_Ensenada',
    description: 'Display name for the America/Ensenada timezone',
    defaultMessage: 'America - Ensenada',
  }),
  'America/Fort_Nelson': message({
    id: 'sail_timezones.timezone.America_Fort_Nelson',
    description: 'Display name for the America/Fort_Nelson timezone',
    defaultMessage: 'America - Fort Nelson',
  }),
  'America/Fort_Wayne': message({
    id: 'sail_timezones.timezone.America_Fort_Wayne',
    description: 'Display name for the America/Fort_Wayne timezone',
    defaultMessage: 'America - Fort Wayne',
  }),
  'America/Fortaleza': message({
    id: 'sail_timezones.timezone.America_Fortaleza',
    description: 'Display name for the America/Fortaleza timezone',
    defaultMessage: 'America - Fortaleza',
  }),
  'America/Glace_Bay': message({
    id: 'sail_timezones.timezone.America_Glace_Bay',
    description: 'Display name for the America/Glace_Bay timezone',
    defaultMessage: 'America - Glace Bay',
  }),
  'America/Godthab': message({
    id: 'sail_timezones.timezone.America_Godthab',
    description: 'Display name for the America/Godthab timezone',
    defaultMessage: 'America - Godthab',
  }),
  'America/Goose_Bay': message({
    id: 'sail_timezones.timezone.America_Goose_Bay',
    description: 'Display name for the America/Goose_Bay timezone',
    defaultMessage: 'America - Goose Bay',
  }),
  'America/Grand_Turk': message({
    id: 'sail_timezones.timezone.America_Grand_Turk',
    description: 'Display name for the America/Grand_Turk timezone',
    defaultMessage: 'America - Grand Turk',
  }),
  'America/Grenada': message({
    id: 'sail_timezones.timezone.America_Grenada',
    description: 'Display name for the America/Grenada timezone',
    defaultMessage: 'America - Grenada',
  }),
  'America/Guadeloupe': message({
    id: 'sail_timezones.timezone.America_Guadeloupe',
    description: 'Display name for the America/Guadeloupe timezone',
    defaultMessage: 'America - Guadeloupe',
  }),
  'America/Guatemala': message({
    id: 'sail_timezones.timezone.America_Guatemala',
    description: 'Display name for the America/Guatemala timezone',
    defaultMessage: 'America - Guatemala',
  }),
  'America/Guayaquil': message({
    id: 'sail_timezones.timezone.America_Guayaquil',
    description: 'Display name for the America/Guayaquil timezone',
    defaultMessage: 'America - Guayaquil',
  }),
  'America/Guyana': message({
    id: 'sail_timezones.timezone.America_Guyana',
    description: 'Display name for the America/Guyana timezone',
    defaultMessage: 'America - Guyana',
  }),
  'America/Halifax': message({
    id: 'sail_timezones.timezone.America_Halifax',
    description: 'Display name for the America/Halifax timezone',
    defaultMessage: 'America - Halifax',
  }),
  'America/Havana': message({
    id: 'sail_timezones.timezone.America_Havana',
    description: 'Display name for the America/Havana timezone',
    defaultMessage: 'America - Havana',
  }),
  'America/Hermosillo': message({
    id: 'sail_timezones.timezone.America_Hermosillo',
    description: 'Display name for the America/Hermosillo timezone',
    defaultMessage: 'America - Hermosillo',
  }),
  'America/Indiana/Indianapolis': message({
    id: 'sail_timezones.timezone.America_Indiana_Indianapolis',
    description: 'Display name for the America/Indiana/Indianapolis timezone',
    defaultMessage: 'America - Indianapolis, Indiana',
  }),
  'America/Indiana/Knox': message({
    id: 'sail_timezones.timezone.America_Indiana_Knox',
    description: 'Display name for the America/Indiana/Knox timezone',
    defaultMessage: 'America - Knox, Indiana',
  }),
  'America/Indiana/Marengo': message({
    id: 'sail_timezones.timezone.America_Indiana_Marengo',
    description: 'Display name for the America/Indiana/Marengo timezone',
    defaultMessage: 'America - Marengo, Indiana',
  }),
  'America/Indiana/Petersburg': message({
    id: 'sail_timezones.timezone.America_Indiana_Petersburg',
    description: 'Display name for the America/Indiana/Petersburg timezone',
    defaultMessage: 'America - Petersburg, Indiana',
  }),
  'America/Indiana/Tell_City': message({
    id: 'sail_timezones.timezone.America_Indiana_Tell_City',
    description: 'Display name for the America/Indiana/Tell_City timezone',
    defaultMessage: 'America - Tell City, Indiana',
  }),
  'America/Indiana/Vevay': message({
    id: 'sail_timezones.timezone.America_Indiana_Vevay',
    description: 'Display name for the America/Indiana/Vevay timezone',
    defaultMessage: 'America - Vevay, Indiana',
  }),
  'America/Indiana/Vincennes': message({
    id: 'sail_timezones.timezone.America_Indiana_Vincennes',
    description: 'Display name for the America/Indiana/Vincennes timezone',
    defaultMessage: 'America - Vincennes, Indiana',
  }),
  'America/Indiana/Winamac': message({
    id: 'sail_timezones.timezone.America_Indiana_Winamac',
    description: 'Display name for the America/Indiana/Winamac timezone',
    defaultMessage: 'America - Winamac, Indiana',
  }),
  'America/Indianapolis': message({
    id: 'sail_timezones.timezone.America_Indianapolis',
    description: 'Display name for the America/Indianapolis timezone',
    defaultMessage: 'America - Indianapolis',
  }),
  'America/Inuvik': message({
    id: 'sail_timezones.timezone.America_Inuvik',
    description: 'Display name for the America/Inuvik timezone',
    defaultMessage: 'America - Inuvik',
  }),
  'America/Iqaluit': message({
    id: 'sail_timezones.timezone.America_Iqaluit',
    description: 'Display name for the America/Iqaluit timezone',
    defaultMessage: 'America - Iqaluit',
  }),
  'America/Jamaica': message({
    id: 'sail_timezones.timezone.America_Jamaica',
    description: 'Display name for the America/Jamaica timezone',
    defaultMessage: 'America - Jamaica',
  }),
  'America/Jujuy': message({
    id: 'sail_timezones.timezone.America_Jujuy',
    description: 'Display name for the America/Jujuy timezone',
    defaultMessage: 'America - Jujuy',
  }),
  'America/Juneau': message({
    id: 'sail_timezones.timezone.America_Juneau',
    description: 'Display name for the America/Juneau timezone',
    defaultMessage: 'America - Juneau',
  }),
  'America/Kentucky/Louisville': message({
    id: 'sail_timezones.timezone.America_Kentucky_Louisville',
    description: 'Display name for the America/Kentucky/Louisville timezone',
    defaultMessage: 'America - Louisville, Kentucky',
  }),
  'America/Kentucky/Monticello': message({
    id: 'sail_timezones.timezone.America_Kentucky_Monticello',
    description: 'Display name for the America/Kentucky/Monticello timezone',
    defaultMessage: 'America - Monticello, Kentucky',
  }),
  'America/Knox_IN': message({
    id: 'sail_timezones.timezone.America_Knox_IN',
    description: 'Display name for the America/Knox_IN timezone',
    defaultMessage: "America - Knox I'N",
  }),
  'America/Kralendijk': message({
    id: 'sail_timezones.timezone.America_Kralendijk',
    description: 'Display name for the America/Kralendijk timezone',
    defaultMessage: 'America - Kralendijk',
  }),
  'America/La_Paz': message({
    id: 'sail_timezones.timezone.America_La_Paz',
    description: 'Display name for the America/La_Paz timezone',
    defaultMessage: 'America - La Paz',
  }),
  'America/Lima': message({
    id: 'sail_timezones.timezone.America_Lima',
    description: 'Display name for the America/Lima timezone',
    defaultMessage: 'America - Lima',
  }),
  'America/Los_Angeles': message({
    id: 'sail_timezones.timezone.America_Los_Angeles',
    description: 'Display name for the America/Los_Angeles timezone',
    defaultMessage: 'America - Los Angeles',
  }),
  'America/Louisville': message({
    id: 'sail_timezones.timezone.America_Louisville',
    description: 'Display name for the America/Louisville timezone',
    defaultMessage: 'America - Louisville',
  }),
  'America/Lower_Princes': message({
    id: 'sail_timezones.timezone.America_Lower_Princes',
    description: 'Display name for the America/Lower_Princes timezone',
    defaultMessage: 'America - Lower Princes',
  }),
  'America/Maceio': message({
    id: 'sail_timezones.timezone.America_Maceio',
    description: 'Display name for the America/Maceio timezone',
    defaultMessage: 'America - Maceio',
  }),
  'America/Managua': message({
    id: 'sail_timezones.timezone.America_Managua',
    description: 'Display name for the America/Managua timezone',
    defaultMessage: 'America - Managua',
  }),
  'America/Manaus': message({
    id: 'sail_timezones.timezone.America_Manaus',
    description: 'Display name for the America/Manaus timezone',
    defaultMessage: 'America - Manaus',
  }),
  'America/Marigot': message({
    id: 'sail_timezones.timezone.America_Marigot',
    description: 'Display name for the America/Marigot timezone',
    defaultMessage: 'America - Marigot',
  }),
  'America/Martinique': message({
    id: 'sail_timezones.timezone.America_Martinique',
    description: 'Display name for the America/Martinique timezone',
    defaultMessage: 'America - Martinique',
  }),
  'America/Matamoros': message({
    id: 'sail_timezones.timezone.America_Matamoros',
    description: 'Display name for the America/Matamoros timezone',
    defaultMessage: 'America - Matamoros',
  }),
  'America/Mazatlan': message({
    id: 'sail_timezones.timezone.America_Mazatlan',
    description: 'Display name for the America/Mazatlan timezone',
    defaultMessage: 'America - Mazatlan',
  }),
  'America/Mendoza': message({
    id: 'sail_timezones.timezone.America_Mendoza',
    description: 'Display name for the America/Mendoza timezone',
    defaultMessage: 'America - Mendoza',
  }),
  'America/Menominee': message({
    id: 'sail_timezones.timezone.America_Menominee',
    description: 'Display name for the America/Menominee timezone',
    defaultMessage: 'America - Menominee',
  }),
  'America/Merida': message({
    id: 'sail_timezones.timezone.America_Merida',
    description: 'Display name for the America/Merida timezone',
    defaultMessage: 'America - Merida',
  }),
  'America/Metlakatla': message({
    id: 'sail_timezones.timezone.America_Metlakatla',
    description: 'Display name for the America/Metlakatla timezone',
    defaultMessage: 'America - Metlakatla',
  }),
  'America/Mexico_City': message({
    id: 'sail_timezones.timezone.America_Mexico_City',
    description: 'Display name for the America/Mexico_City timezone',
    defaultMessage: 'America - Mexico City',
  }),
  'America/Miquelon': message({
    id: 'sail_timezones.timezone.America_Miquelon',
    description: 'Display name for the America/Miquelon timezone',
    defaultMessage: 'America - Miquelon',
  }),
  'America/Moncton': message({
    id: 'sail_timezones.timezone.America_Moncton',
    description: 'Display name for the America/Moncton timezone',
    defaultMessage: 'America - Moncton',
  }),
  'America/Monterrey': message({
    id: 'sail_timezones.timezone.America_Monterrey',
    description: 'Display name for the America/Monterrey timezone',
    defaultMessage: 'America - Monterrey',
  }),
  'America/Montevideo': message({
    id: 'sail_timezones.timezone.America_Montevideo',
    description: 'Display name for the America/Montevideo timezone',
    defaultMessage: 'America - Montevideo',
  }),
  'America/Montreal': message({
    id: 'sail_timezones.timezone.America_Montreal',
    description: 'Display name for the America/Montreal timezone',
    defaultMessage: 'America - Montreal',
  }),
  'America/Montserrat': message({
    id: 'sail_timezones.timezone.America_Montserrat',
    description: 'Display name for the America/Montserrat timezone',
    defaultMessage: 'America - Montserrat',
  }),
  'America/Nassau': message({
    id: 'sail_timezones.timezone.America_Nassau',
    description: 'Display name for the America/Nassau timezone',
    defaultMessage: 'America - Nassau',
  }),
  'America/New_York': message({
    id: 'sail_timezones.timezone.America_New_York',
    description: 'Display name for the America/New_York timezone',
    defaultMessage: 'America - New York',
  }),
  'America/Nipigon': message({
    id: 'sail_timezones.timezone.America_Nipigon',
    description: 'Display name for the America/Nipigon timezone',
    defaultMessage: 'America - Nipigon',
  }),
  'America/Nome': message({
    id: 'sail_timezones.timezone.America_Nome',
    description: 'Display name for the America/Nome timezone',
    defaultMessage: 'America - Nome',
  }),
  'America/Noronha': message({
    id: 'sail_timezones.timezone.America_Noronha',
    description: 'Display name for the America/Noronha timezone',
    defaultMessage: 'America - Noronha',
  }),
  'America/North_Dakota/Beulah': message({
    id: 'sail_timezones.timezone.America_North_Dakota_Beulah',
    description: 'Display name for the America/North_Dakota/Beulah timezone',
    defaultMessage: 'America - Beulah, North Dakota',
  }),
  'America/North_Dakota/Center': message({
    id: 'sail_timezones.timezone.America_North_Dakota_Center',
    description: 'Display name for the America/North_Dakota/Center timezone',
    defaultMessage: 'America - Center, North Dakota',
  }),
  'America/North_Dakota/New_Salem': message({
    id: 'sail_timezones.timezone.America_North_Dakota_New_Salem',
    description: 'Display name for the America/North_Dakota/New_Salem timezone',
    defaultMessage: 'America - New Salem, North Dakota',
  }),
  'America/Ojinaga': message({
    id: 'sail_timezones.timezone.America_Ojinaga',
    description: 'Display name for the America/Ojinaga timezone',
    defaultMessage: 'America - Ojinaga',
  }),
  'America/Panama': message({
    id: 'sail_timezones.timezone.America_Panama',
    description: 'Display name for the America/Panama timezone',
    defaultMessage: 'America - Panama',
  }),
  'America/Pangnirtung': message({
    id: 'sail_timezones.timezone.America_Pangnirtung',
    description: 'Display name for the America/Pangnirtung timezone',
    defaultMessage: 'America - Pangnirtung',
  }),
  'America/Paramaribo': message({
    id: 'sail_timezones.timezone.America_Paramaribo',
    description: 'Display name for the America/Paramaribo timezone',
    defaultMessage: 'America - Paramaribo',
  }),
  'America/Phoenix': message({
    id: 'sail_timezones.timezone.America_Phoenix',
    description: 'Display name for the America/Phoenix timezone',
    defaultMessage: 'America - Phoenix',
  }),
  'America/Port-au-Prince': message({
    id: 'sail_timezones.timezone.America_Port-au-Prince',
    description: 'Display name for the America/Port-au-Prince timezone',
    defaultMessage: 'America - Port-au-Prince',
  }),
  'America/Port_of_Spain': message({
    id: 'sail_timezones.timezone.America_Port_of_Spain',
    description: 'Display name for the America/Port_of_Spain timezone',
    defaultMessage: 'America - Port of Spain',
  }),
  'America/Porto_Acre': message({
    id: 'sail_timezones.timezone.America_Porto_Acre',
    description: 'Display name for the America/Porto_Acre timezone',
    defaultMessage: 'America - Porto Acre',
  }),
  'America/Porto_Velho': message({
    id: 'sail_timezones.timezone.America_Porto_Velho',
    description: 'Display name for the America/Porto_Velho timezone',
    defaultMessage: 'America - Porto Velho',
  }),
  'America/Puerto_Rico': message({
    id: 'sail_timezones.timezone.America_Puerto_Rico',
    description: 'Display name for the America/Puerto_Rico timezone',
    defaultMessage: 'America - Puerto Rico',
  }),
  'America/Punta_Arenas': message({
    id: 'sail_timezones.timezone.America_Punta_Arenas',
    description: 'Display name for the America/Punta_Arenas timezone',
    defaultMessage: 'America - Punta Arenas',
  }),
  'America/Rainy_River': message({
    id: 'sail_timezones.timezone.America_Rainy_River',
    description: 'Display name for the America/Rainy_River timezone',
    defaultMessage: 'America - Rainy River',
  }),
  'America/Rankin_Inlet': message({
    id: 'sail_timezones.timezone.America_Rankin_Inlet',
    description: 'Display name for the America/Rankin_Inlet timezone',
    defaultMessage: 'America - Rankin Inlet',
  }),
  'America/Recife': message({
    id: 'sail_timezones.timezone.America_Recife',
    description: 'Display name for the America/Recife timezone',
    defaultMessage: 'America - Recife',
  }),
  'America/Regina': message({
    id: 'sail_timezones.timezone.America_Regina',
    description: 'Display name for the America/Regina timezone',
    defaultMessage: 'America - Regina',
  }),
  'America/Resolute': message({
    id: 'sail_timezones.timezone.America_Resolute',
    description: 'Display name for the America/Resolute timezone',
    defaultMessage: 'America - Resolute',
  }),
  'America/Rio_Branco': message({
    id: 'sail_timezones.timezone.America_Rio_Branco',
    description: 'Display name for the America/Rio_Branco timezone',
    defaultMessage: 'America - Rio Branco',
  }),
  'America/Rosario': message({
    id: 'sail_timezones.timezone.America_Rosario',
    description: 'Display name for the America/Rosario timezone',
    defaultMessage: 'America - Rosario',
  }),
  'America/Santa_Isabel': message({
    id: 'sail_timezones.timezone.America_Santa_Isabel',
    description: 'Display name for the America/Santa_Isabel timezone',
    defaultMessage: 'America - Santa Isabel',
  }),
  'America/Santarem': message({
    id: 'sail_timezones.timezone.America_Santarem',
    description: 'Display name for the America/Santarem timezone',
    defaultMessage: 'America - Santarem',
  }),
  'America/Santiago': message({
    id: 'sail_timezones.timezone.America_Santiago',
    description: 'Display name for the America/Santiago timezone',
    defaultMessage: 'America - Santiago',
  }),
  'America/Santo_Domingo': message({
    id: 'sail_timezones.timezone.America_Santo_Domingo',
    description: 'Display name for the America/Santo_Domingo timezone',
    defaultMessage: 'America - Santo Domingo',
  }),
  'America/Sao_Paulo': message({
    id: 'sail_timezones.timezone.America_Sao_Paulo',
    description: 'Display name for the America/Sao_Paulo timezone',
    defaultMessage: 'America - Sao Paulo',
  }),
  'America/Scoresbysund': message({
    id: 'sail_timezones.timezone.America_Scoresbysund',
    description: 'Display name for the America/Scoresbysund timezone',
    defaultMessage: 'America - Scoresbysund',
  }),
  'America/Shiprock': message({
    id: 'sail_timezones.timezone.America_Shiprock',
    description: 'Display name for the America/Shiprock timezone',
    defaultMessage: 'America - Shiprock',
  }),
  'America/Sitka': message({
    id: 'sail_timezones.timezone.America_Sitka',
    description: 'Display name for the America/Sitka timezone',
    defaultMessage: 'America - Sitka',
  }),
  'America/St_Barthelemy': message({
    id: 'sail_timezones.timezone.America_St_Barthelemy',
    description: 'Display name for the America/St_Barthelemy timezone',
    defaultMessage: 'America - St Barthelemy',
  }),
  'America/St_Johns': message({
    id: 'sail_timezones.timezone.America_St_Johns',
    description: 'Display name for the America/St_Johns timezone',
    defaultMessage: 'America - St Johns',
  }),
  'America/St_Kitts': message({
    id: 'sail_timezones.timezone.America_St_Kitts',
    description: 'Display name for the America/St_Kitts timezone',
    defaultMessage: 'America - St Kitts',
  }),
  'America/St_Lucia': message({
    id: 'sail_timezones.timezone.America_St_Lucia',
    description: 'Display name for the America/St_Lucia timezone',
    defaultMessage: 'America - St Lucia',
  }),
  'America/St_Thomas': message({
    id: 'sail_timezones.timezone.America_St_Thomas',
    description: 'Display name for the America/St_Thomas timezone',
    defaultMessage: 'America - St Thomas',
  }),
  'America/St_Vincent': message({
    id: 'sail_timezones.timezone.America_St_Vincent',
    description: 'Display name for the America/St_Vincent timezone',
    defaultMessage: 'America - St Vincent',
  }),
  'America/Swift_Current': message({
    id: 'sail_timezones.timezone.America_Swift_Current',
    description: 'Display name for the America/Swift_Current timezone',
    defaultMessage: 'America - Swift Current',
  }),
  'America/Tegucigalpa': message({
    id: 'sail_timezones.timezone.America_Tegucigalpa',
    description: 'Display name for the America/Tegucigalpa timezone',
    defaultMessage: 'America - Tegucigalpa',
  }),
  'America/Thule': message({
    id: 'sail_timezones.timezone.America_Thule',
    description: 'Display name for the America/Thule timezone',
    defaultMessage: 'America - Thule',
  }),
  'America/Thunder_Bay': message({
    id: 'sail_timezones.timezone.America_Thunder_Bay',
    description: 'Display name for the America/Thunder_Bay timezone',
    defaultMessage: 'America - Thunder Bay',
  }),
  'America/Tijuana': message({
    id: 'sail_timezones.timezone.America_Tijuana',
    description: 'Display name for the America/Tijuana timezone',
    defaultMessage: 'America - Tijuana',
  }),
  'America/Toronto': message({
    id: 'sail_timezones.timezone.America_Toronto',
    description: 'Display name for the America/Toronto timezone',
    defaultMessage: 'America - Toronto',
  }),
  'America/Tortola': message({
    id: 'sail_timezones.timezone.America_Tortola',
    description: 'Display name for the America/Tortola timezone',
    defaultMessage: 'America - Tortola',
  }),
  'America/Vancouver': message({
    id: 'sail_timezones.timezone.America_Vancouver',
    description: 'Display name for the America/Vancouver timezone',
    defaultMessage: 'America - Vancouver',
  }),
  'America/Virgin': message({
    id: 'sail_timezones.timezone.America_Virgin',
    description: 'Display name for the America/Virgin timezone',
    defaultMessage: 'America - Virgin',
  }),
  'America/Whitehorse': message({
    id: 'sail_timezones.timezone.America_Whitehorse',
    description: 'Display name for the America/Whitehorse timezone',
    defaultMessage: 'America - Whitehorse',
  }),
  'America/Winnipeg': message({
    id: 'sail_timezones.timezone.America_Winnipeg',
    description: 'Display name for the America/Winnipeg timezone',
    defaultMessage: 'America - Winnipeg',
  }),
  'America/Yakutat': message({
    id: 'sail_timezones.timezone.America_Yakutat',
    description: 'Display name for the America/Yakutat timezone',
    defaultMessage: 'America - Yakutat',
  }),
  'America/Yellowknife': message({
    id: 'sail_timezones.timezone.America_Yellowknife',
    description: 'Display name for the America/Yellowknife timezone',
    defaultMessage: 'America - Yellowknife',
  }),
  'Antarctica/Casey': message({
    id: 'sail_timezones.timezone.Antarctica_Casey',
    description: 'Display name for the Antarctica/Casey timezone',
    defaultMessage: 'Antarctica - Casey',
  }),
  'Antarctica/Davis': message({
    id: 'sail_timezones.timezone.Antarctica_Davis',
    description: 'Display name for the Antarctica/Davis timezone',
    defaultMessage: 'Antarctica - Davis',
  }),
  'Antarctica/DumontDUrville': message({
    id: 'sail_timezones.timezone.Antarctica_DumontDUrville',
    description: 'Display name for the Antarctica/DumontDUrville timezone',
    defaultMessage: "Antarctica - Dumont D'Urville",
  }),
  'Antarctica/Macquarie': message({
    id: 'sail_timezones.timezone.Antarctica_Macquarie',
    description: 'Display name for the Antarctica/Macquarie timezone',
    defaultMessage: 'Antarctica - Macquarie',
  }),
  'Antarctica/Mawson': message({
    id: 'sail_timezones.timezone.Antarctica_Mawson',
    description: 'Display name for the Antarctica/Mawson timezone',
    defaultMessage: 'Antarctica - Mawson',
  }),
  'Antarctica/McMurdo': message({
    id: 'sail_timezones.timezone.Antarctica_McMurdo',
    description: 'Display name for the Antarctica/McMurdo timezone',
    defaultMessage: 'Antarctica - McMurdo',
  }),
  'Antarctica/Palmer': message({
    id: 'sail_timezones.timezone.Antarctica_Palmer',
    description: 'Display name for the Antarctica/Palmer timezone',
    defaultMessage: 'Antarctica - Palmer',
  }),
  'Antarctica/Rothera': message({
    id: 'sail_timezones.timezone.Antarctica_Rothera',
    description: 'Display name for the Antarctica/Rothera timezone',
    defaultMessage: 'Antarctica - Rothera',
  }),
  'Antarctica/South_Pole': message({
    id: 'sail_timezones.timezone.Antarctica_South_Pole',
    description: 'Display name for the Antarctica/South_Pole timezone',
    defaultMessage: 'Antarctica - South Pole',
  }),
  'Antarctica/Syowa': message({
    id: 'sail_timezones.timezone.Antarctica_Syowa',
    description: 'Display name for the Antarctica/Syowa timezone',
    defaultMessage: 'Antarctica - Syowa',
  }),
  'Antarctica/Troll': message({
    id: 'sail_timezones.timezone.Antarctica_Troll',
    description: 'Display name for the Antarctica/Troll timezone',
    defaultMessage: 'Antarctica - Troll',
  }),
  'Antarctica/Vostok': message({
    id: 'sail_timezones.timezone.Antarctica_Vostok',
    description: 'Display name for the Antarctica/Vostok timezone',
    defaultMessage: 'Antarctica - Vostok',
  }),
  'Arctic/Longyearbyen': message({
    id: 'sail_timezones.timezone.Arctic_Longyearbyen',
    description: 'Display name for the Arctic/Longyearbyen timezone',
    defaultMessage: 'Arctic - Longyearbyen',
  }),
  'Asia/Aden': message({
    id: 'sail_timezones.timezone.Asia_Aden',
    description: 'Display name for the Asia/Aden timezone',
    defaultMessage: 'Asia - Aden',
  }),
  'Asia/Almaty': message({
    id: 'sail_timezones.timezone.Asia_Almaty',
    description: 'Display name for the Asia/Almaty timezone',
    defaultMessage: 'Asia - Almaty',
  }),
  'Asia/Amman': message({
    id: 'sail_timezones.timezone.Asia_Amman',
    description: 'Display name for the Asia/Amman timezone',
    defaultMessage: 'Asia - Amman',
  }),
  'Asia/Anadyr': message({
    id: 'sail_timezones.timezone.Asia_Anadyr',
    description: 'Display name for the Asia/Anadyr timezone',
    defaultMessage: 'Asia - Anadyr',
  }),
  'Asia/Aqtau': message({
    id: 'sail_timezones.timezone.Asia_Aqtau',
    description: 'Display name for the Asia/Aqtau timezone',
    defaultMessage: 'Asia - Aqtau',
  }),
  'Asia/Aqtobe': message({
    id: 'sail_timezones.timezone.Asia_Aqtobe',
    description: 'Display name for the Asia/Aqtobe timezone',
    defaultMessage: 'Asia - Aqtobe',
  }),
  'Asia/Ashgabat': message({
    id: 'sail_timezones.timezone.Asia_Ashgabat',
    description: 'Display name for the Asia/Ashgabat timezone',
    defaultMessage: 'Asia - Ashgabat',
  }),
  'Asia/Ashkhabad': message({
    id: 'sail_timezones.timezone.Asia_Ashkhabad',
    description: 'Display name for the Asia/Ashkhabad timezone',
    defaultMessage: 'Asia - Ashkhabad',
  }),
  'Asia/Atyrau': message({
    id: 'sail_timezones.timezone.Asia_Atyrau',
    description: 'Display name for the Asia/Atyrau timezone',
    defaultMessage: 'Asia - Atyrau',
  }),
  'Asia/Baghdad': message({
    id: 'sail_timezones.timezone.Asia_Baghdad',
    description: 'Display name for the Asia/Baghdad timezone',
    defaultMessage: 'Asia - Baghdad',
  }),
  'Asia/Bahrain': message({
    id: 'sail_timezones.timezone.Asia_Bahrain',
    description: 'Display name for the Asia/Bahrain timezone',
    defaultMessage: 'Asia - Bahrain',
  }),
  'Asia/Baku': message({
    id: 'sail_timezones.timezone.Asia_Baku',
    description: 'Display name for the Asia/Baku timezone',
    defaultMessage: 'Asia - Baku',
  }),
  'Asia/Bangkok': message({
    id: 'sail_timezones.timezone.Asia_Bangkok',
    description: 'Display name for the Asia/Bangkok timezone',
    defaultMessage: 'Asia - Bangkok',
  }),
  'Asia/Barnaul': message({
    id: 'sail_timezones.timezone.Asia_Barnaul',
    description: 'Display name for the Asia/Barnaul timezone',
    defaultMessage: 'Asia - Barnaul',
  }),
  'Asia/Beirut': message({
    id: 'sail_timezones.timezone.Asia_Beirut',
    description: 'Display name for the Asia/Beirut timezone',
    defaultMessage: 'Asia - Beirut',
  }),
  'Asia/Bishkek': message({
    id: 'sail_timezones.timezone.Asia_Bishkek',
    description: 'Display name for the Asia/Bishkek timezone',
    defaultMessage: 'Asia - Bishkek',
  }),
  'Asia/Brunei': message({
    id: 'sail_timezones.timezone.Asia_Brunei',
    description: 'Display name for the Asia/Brunei timezone',
    defaultMessage: 'Asia - Brunei',
  }),
  'Asia/Calcutta': message({
    id: 'sail_timezones.timezone.Asia_Calcutta',
    description: 'Display name for the Asia/Calcutta timezone',
    defaultMessage: 'Asia - Calcutta',
  }),
  'Asia/Chita': message({
    id: 'sail_timezones.timezone.Asia_Chita',
    description: 'Display name for the Asia/Chita timezone',
    defaultMessage: 'Asia - Chita',
  }),
  'Asia/Choibalsan': message({
    id: 'sail_timezones.timezone.Asia_Choibalsan',
    description: 'Display name for the Asia/Choibalsan timezone',
    defaultMessage: 'Asia - Choibalsan',
  }),
  'Asia/Chongqing': message({
    id: 'sail_timezones.timezone.Asia_Chongqing',
    description: 'Display name for the Asia/Chongqing timezone',
    defaultMessage: 'Asia - Chongqing',
  }),
  'Asia/Chungking': message({
    id: 'sail_timezones.timezone.Asia_Chungking',
    description: 'Display name for the Asia/Chungking timezone',
    defaultMessage: 'Asia - Chungking',
  }),
  'Asia/Colombo': message({
    id: 'sail_timezones.timezone.Asia_Colombo',
    description: 'Display name for the Asia/Colombo timezone',
    defaultMessage: 'Asia - Colombo',
  }),
  'Asia/Dacca': message({
    id: 'sail_timezones.timezone.Asia_Dacca',
    description: 'Display name for the Asia/Dacca timezone',
    defaultMessage: 'Asia - Dacca',
  }),
  'Asia/Damascus': message({
    id: 'sail_timezones.timezone.Asia_Damascus',
    description: 'Display name for the Asia/Damascus timezone',
    defaultMessage: 'Asia - Damascus',
  }),
  'Asia/Dhaka': message({
    id: 'sail_timezones.timezone.Asia_Dhaka',
    description: 'Display name for the Asia/Dhaka timezone',
    defaultMessage: 'Asia - Dhaka',
  }),
  'Asia/Dili': message({
    id: 'sail_timezones.timezone.Asia_Dili',
    description: 'Display name for the Asia/Dili timezone',
    defaultMessage: 'Asia - Dili',
  }),
  'Asia/Dubai': message({
    id: 'sail_timezones.timezone.Asia_Dubai',
    description: 'Display name for the Asia/Dubai timezone',
    defaultMessage: 'Asia - Dubai',
  }),
  'Asia/Dushanbe': message({
    id: 'sail_timezones.timezone.Asia_Dushanbe',
    description: 'Display name for the Asia/Dushanbe timezone',
    defaultMessage: 'Asia - Dushanbe',
  }),
  'Asia/Famagusta': message({
    id: 'sail_timezones.timezone.Asia_Famagusta',
    description: 'Display name for the Asia/Famagusta timezone',
    defaultMessage: 'Asia - Famagusta',
  }),
  'Asia/Gaza': message({
    id: 'sail_timezones.timezone.Asia_Gaza',
    description: 'Display name for the Asia/Gaza timezone',
    defaultMessage: 'Asia - Gaza',
  }),
  'Asia/Harbin': message({
    id: 'sail_timezones.timezone.Asia_Harbin',
    description: 'Display name for the Asia/Harbin timezone',
    defaultMessage: 'Asia - Harbin',
  }),
  'Asia/Hebron': message({
    id: 'sail_timezones.timezone.Asia_Hebron',
    description: 'Display name for the Asia/Hebron timezone',
    defaultMessage: 'Asia - Hebron',
  }),
  'Asia/Ho_Chi_Minh': message({
    id: 'sail_timezones.timezone.Asia_Ho_Chi_Minh',
    description: 'Display name for the Asia/Ho_Chi_Minh timezone',
    defaultMessage: 'Asia - Ho Chi Minh',
  }),
  'Asia/Hong_Kong': message({
    id: 'sail_timezones.timezone.Asia_Hong_Kong',
    description: 'Display name for the Asia/Hong_Kong timezone',
    defaultMessage: 'Asia - Hong Kong',
  }),
  'Asia/Hovd': message({
    id: 'sail_timezones.timezone.Asia_Hovd',
    description: 'Display name for the Asia/Hovd timezone',
    defaultMessage: 'Asia - Hovd',
  }),
  'Asia/Irkutsk': message({
    id: 'sail_timezones.timezone.Asia_Irkutsk',
    description: 'Display name for the Asia/Irkutsk timezone',
    defaultMessage: 'Asia - Irkutsk',
  }),
  'Asia/Istanbul': message({
    id: 'sail_timezones.timezone.Asia_Istanbul',
    description: 'Display name for the Asia/Istanbul timezone',
    defaultMessage: 'Asia - Istanbul',
  }),
  'Asia/Jakarta': message({
    id: 'sail_timezones.timezone.Asia_Jakarta',
    description: 'Display name for the Asia/Jakarta timezone',
    defaultMessage: 'Asia - Jakarta',
  }),
  'Asia/Jayapura': message({
    id: 'sail_timezones.timezone.Asia_Jayapura',
    description: 'Display name for the Asia/Jayapura timezone',
    defaultMessage: 'Asia - Jayapura',
  }),
  'Asia/Jerusalem': message({
    id: 'sail_timezones.timezone.Asia_Jerusalem',
    description: 'Display name for the Asia/Jerusalem timezone',
    defaultMessage: 'Asia - Jerusalem',
  }),
  'Asia/Kabul': message({
    id: 'sail_timezones.timezone.Asia_Kabul',
    description: 'Display name for the Asia/Kabul timezone',
    defaultMessage: 'Asia - Kabul',
  }),
  'Asia/Kamchatka': message({
    id: 'sail_timezones.timezone.Asia_Kamchatka',
    description: 'Display name for the Asia/Kamchatka timezone',
    defaultMessage: 'Asia - Kamchatka',
  }),
  'Asia/Karachi': message({
    id: 'sail_timezones.timezone.Asia_Karachi',
    description: 'Display name for the Asia/Karachi timezone',
    defaultMessage: 'Asia - Karachi',
  }),
  'Asia/Kashgar': message({
    id: 'sail_timezones.timezone.Asia_Kashgar',
    description: 'Display name for the Asia/Kashgar timezone',
    defaultMessage: 'Asia - Kashgar',
  }),
  'Asia/Kathmandu': message({
    id: 'sail_timezones.timezone.Asia_Kathmandu',
    description: 'Display name for the Asia/Kathmandu timezone',
    defaultMessage: 'Asia - Kathmandu',
  }),
  'Asia/Katmandu': message({
    id: 'sail_timezones.timezone.Asia_Katmandu',
    description: 'Display name for the Asia/Katmandu timezone',
    defaultMessage: 'Asia - Katmandu',
  }),
  'Asia/Khandyga': message({
    id: 'sail_timezones.timezone.Asia_Khandyga',
    description: 'Display name for the Asia/Khandyga timezone',
    defaultMessage: 'Asia - Khandyga',
  }),
  'Asia/Kolkata': message({
    id: 'sail_timezones.timezone.Asia_Kolkata',
    description: 'Display name for the Asia/Kolkata timezone',
    defaultMessage: 'Asia - Kolkata',
  }),
  'Asia/Krasnoyarsk': message({
    id: 'sail_timezones.timezone.Asia_Krasnoyarsk',
    description: 'Display name for the Asia/Krasnoyarsk timezone',
    defaultMessage: 'Asia - Krasnoyarsk',
  }),
  'Asia/Kuala_Lumpur': message({
    id: 'sail_timezones.timezone.Asia_Kuala_Lumpur',
    description: 'Display name for the Asia/Kuala_Lumpur timezone',
    defaultMessage: 'Asia - Kuala Lumpur',
  }),
  'Asia/Kuching': message({
    id: 'sail_timezones.timezone.Asia_Kuching',
    description: 'Display name for the Asia/Kuching timezone',
    defaultMessage: 'Asia - Kuching',
  }),
  'Asia/Kuwait': message({
    id: 'sail_timezones.timezone.Asia_Kuwait',
    description: 'Display name for the Asia/Kuwait timezone',
    defaultMessage: 'Asia - Kuwait',
  }),
  'Asia/Macao': message({
    id: 'sail_timezones.timezone.Asia_Macao',
    description: 'Display name for the Asia/Macao timezone',
    defaultMessage: 'Asia - Macao',
  }),
  'Asia/Macau': message({
    id: 'sail_timezones.timezone.Asia_Macau',
    description: 'Display name for the Asia/Macau timezone',
    defaultMessage: 'Asia - Macau',
  }),
  'Asia/Magadan': message({
    id: 'sail_timezones.timezone.Asia_Magadan',
    description: 'Display name for the Asia/Magadan timezone',
    defaultMessage: 'Asia - Magadan',
  }),
  'Asia/Makassar': message({
    id: 'sail_timezones.timezone.Asia_Makassar',
    description: 'Display name for the Asia/Makassar timezone',
    defaultMessage: 'Asia - Makassar',
  }),
  'Asia/Manila': message({
    id: 'sail_timezones.timezone.Asia_Manila',
    description: 'Display name for the Asia/Manila timezone',
    defaultMessage: 'Asia - Manila',
  }),
  'Asia/Muscat': message({
    id: 'sail_timezones.timezone.Asia_Muscat',
    description: 'Display name for the Asia/Muscat timezone',
    defaultMessage: 'Asia - Muscat',
  }),
  'Asia/Nicosia': message({
    id: 'sail_timezones.timezone.Asia_Nicosia',
    description: 'Display name for the Asia/Nicosia timezone',
    defaultMessage: 'Asia - Nicosia',
  }),
  'Asia/Novokuznetsk': message({
    id: 'sail_timezones.timezone.Asia_Novokuznetsk',
    description: 'Display name for the Asia/Novokuznetsk timezone',
    defaultMessage: 'Asia - Novokuznetsk',
  }),
  'Asia/Novosibirsk': message({
    id: 'sail_timezones.timezone.Asia_Novosibirsk',
    description: 'Display name for the Asia/Novosibirsk timezone',
    defaultMessage: 'Asia - Novosibirsk',
  }),
  'Asia/Omsk': message({
    id: 'sail_timezones.timezone.Asia_Omsk',
    description: 'Display name for the Asia/Omsk timezone',
    defaultMessage: 'Asia - Omsk',
  }),
  'Asia/Oral': message({
    id: 'sail_timezones.timezone.Asia_Oral',
    description: 'Display name for the Asia/Oral timezone',
    defaultMessage: 'Asia - Oral',
  }),
  'Asia/Phnom_Penh': message({
    id: 'sail_timezones.timezone.Asia_Phnom_Penh',
    description: 'Display name for the Asia/Phnom_Penh timezone',
    defaultMessage: 'Asia - Phnom Penh',
  }),
  'Asia/Pontianak': message({
    id: 'sail_timezones.timezone.Asia_Pontianak',
    description: 'Display name for the Asia/Pontianak timezone',
    defaultMessage: 'Asia - Pontianak',
  }),
  'Asia/Pyongyang': message({
    id: 'sail_timezones.timezone.Asia_Pyongyang',
    description: 'Display name for the Asia/Pyongyang timezone',
    defaultMessage: 'Asia - Pyongyang',
  }),
  'Asia/Qatar': message({
    id: 'sail_timezones.timezone.Asia_Qatar',
    description: 'Display name for the Asia/Qatar timezone',
    defaultMessage: 'Asia - Qatar',
  }),
  'Asia/Qostanay': message({
    id: 'sail_timezones.timezone.Asia_Qostanay',
    description: 'Display name for the Asia/Qostanay timezone',
    defaultMessage: 'Asia - Qostanay',
  }),
  'Asia/Qyzylorda': message({
    id: 'sail_timezones.timezone.Asia_Qyzylorda',
    description: 'Display name for the Asia/Qyzylorda timezone',
    defaultMessage: 'Asia - Qyzylorda',
  }),
  'Asia/Rangoon': message({
    id: 'sail_timezones.timezone.Asia_Rangoon',
    description: 'Display name for the Asia/Rangoon timezone',
    defaultMessage: 'Asia - Rangoon',
  }),
  'Asia/Riyadh': message({
    id: 'sail_timezones.timezone.Asia_Riyadh',
    description: 'Display name for the Asia/Riyadh timezone',
    defaultMessage: 'Asia - Riyadh',
  }),
  'Asia/Saigon': message({
    id: 'sail_timezones.timezone.Asia_Saigon',
    description: 'Display name for the Asia/Saigon timezone',
    defaultMessage: 'Asia - Saigon',
  }),
  'Asia/Sakhalin': message({
    id: 'sail_timezones.timezone.Asia_Sakhalin',
    description: 'Display name for the Asia/Sakhalin timezone',
    defaultMessage: 'Asia - Sakhalin',
  }),
  'Asia/Samarkand': message({
    id: 'sail_timezones.timezone.Asia_Samarkand',
    description: 'Display name for the Asia/Samarkand timezone',
    defaultMessage: 'Asia - Samarkand',
  }),
  'Asia/Seoul': message({
    id: 'sail_timezones.timezone.Asia_Seoul',
    description: 'Display name for the Asia/Seoul timezone',
    defaultMessage: 'Asia - Seoul',
  }),
  'Asia/Shanghai': message({
    id: 'sail_timezones.timezone.Asia_Shanghai',
    description: 'Display name for the Asia/Shanghai timezone',
    defaultMessage: 'Asia - Shanghai',
  }),
  'Asia/Singapore': message({
    id: 'sail_timezones.timezone.Asia_Singapore',
    description: 'Display name for the Asia/Singapore timezone',
    defaultMessage: 'Asia - Singapore',
  }),
  'Asia/Srednekolymsk': message({
    id: 'sail_timezones.timezone.Asia_Srednekolymsk',
    description: 'Display name for the Asia/Srednekolymsk timezone',
    defaultMessage: 'Asia - Srednekolymsk',
  }),
  'Asia/Taipei': message({
    id: 'sail_timezones.timezone.Asia_Taipei',
    description: 'Display name for the Asia/Taipei timezone',
    defaultMessage: 'Asia - Taipei',
  }),
  'Asia/Tashkent': message({
    id: 'sail_timezones.timezone.Asia_Tashkent',
    description: 'Display name for the Asia/Tashkent timezone',
    defaultMessage: 'Asia - Tashkent',
  }),
  'Asia/Tbilisi': message({
    id: 'sail_timezones.timezone.Asia_Tbilisi',
    description: 'Display name for the Asia/Tbilisi timezone',
    defaultMessage: 'Asia - Tbilisi',
  }),
  'Asia/Tehran': message({
    id: 'sail_timezones.timezone.Asia_Tehran',
    description: 'Display name for the Asia/Tehran timezone',
    defaultMessage: 'Asia - Tehran',
  }),
  'Asia/Tel_Aviv': message({
    id: 'sail_timezones.timezone.Asia_Tel_Aviv',
    description: 'Display name for the Asia/Tel_Aviv timezone',
    defaultMessage: 'Asia - Tel Aviv',
  }),
  'Asia/Thimbu': message({
    id: 'sail_timezones.timezone.Asia_Thimbu',
    description: 'Display name for the Asia/Thimbu timezone',
    defaultMessage: 'Asia - Thimbu',
  }),
  'Asia/Thimphu': message({
    id: 'sail_timezones.timezone.Asia_Thimphu',
    description: 'Display name for the Asia/Thimphu timezone',
    defaultMessage: 'Asia - Thimphu',
  }),
  'Asia/Tokyo': message({
    id: 'sail_timezones.timezone.Asia_Tokyo',
    description: 'Display name for the Asia/Tokyo timezone',
    defaultMessage: 'Asia - Tokyo',
  }),
  'Asia/Tomsk': message({
    id: 'sail_timezones.timezone.Asia_Tomsk',
    description: 'Display name for the Asia/Tomsk timezone',
    defaultMessage: 'Asia - Tomsk',
  }),
  'Asia/Ujung_Pandang': message({
    id: 'sail_timezones.timezone.Asia_Ujung_Pandang',
    description: 'Display name for the Asia/Ujung_Pandang timezone',
    defaultMessage: 'Asia - Ujung Pandang',
  }),
  'Asia/Ulaanbaatar': message({
    id: 'sail_timezones.timezone.Asia_Ulaanbaatar',
    description: 'Display name for the Asia/Ulaanbaatar timezone',
    defaultMessage: 'Asia - Ulaanbaatar',
  }),
  'Asia/Ulan_Bator': message({
    id: 'sail_timezones.timezone.Asia_Ulan_Bator',
    description: 'Display name for the Asia/Ulan_Bator timezone',
    defaultMessage: 'Asia - Ulan Bator',
  }),
  'Asia/Urumqi': message({
    id: 'sail_timezones.timezone.Asia_Urumqi',
    description: 'Display name for the Asia/Urumqi timezone',
    defaultMessage: 'Asia - Urumqi',
  }),
  'Asia/Ust-Nera': message({
    id: 'sail_timezones.timezone.Asia_Ust-Nera',
    description: 'Display name for the Asia/Ust-Nera timezone',
    defaultMessage: 'Asia - Ust-Nera',
  }),
  'Asia/Vientiane': message({
    id: 'sail_timezones.timezone.Asia_Vientiane',
    description: 'Display name for the Asia/Vientiane timezone',
    defaultMessage: 'Asia - Vientiane',
  }),
  'Asia/Vladivostok': message({
    id: 'sail_timezones.timezone.Asia_Vladivostok',
    description: 'Display name for the Asia/Vladivostok timezone',
    defaultMessage: 'Asia - Vladivostok',
  }),
  'Asia/Yakutsk': message({
    id: 'sail_timezones.timezone.Asia_Yakutsk',
    description: 'Display name for the Asia/Yakutsk timezone',
    defaultMessage: 'Asia - Yakutsk',
  }),
  'Asia/Yangon': message({
    id: 'sail_timezones.timezone.Asia_Yangon',
    description: 'Display name for the Asia/Yangon timezone',
    defaultMessage: 'Asia - Yangon',
  }),
  'Asia/Yekaterinburg': message({
    id: 'sail_timezones.timezone.Asia_Yekaterinburg',
    description: 'Display name for the Asia/Yekaterinburg timezone',
    defaultMessage: 'Asia - Yekaterinburg',
  }),
  'Asia/Yerevan': message({
    id: 'sail_timezones.timezone.Asia_Yerevan',
    description: 'Display name for the Asia/Yerevan timezone',
    defaultMessage: 'Asia - Yerevan',
  }),
  'Atlantic/Azores': message({
    id: 'sail_timezones.timezone.Atlantic_Azores',
    description: 'Display name for the Atlantic/Azores timezone',
    defaultMessage: 'Atlantic - Azores',
  }),
  'Atlantic/Bermuda': message({
    id: 'sail_timezones.timezone.Atlantic_Bermuda',
    description: 'Display name for the Atlantic/Bermuda timezone',
    defaultMessage: 'Atlantic - Bermuda',
  }),
  'Atlantic/Canary': message({
    id: 'sail_timezones.timezone.Atlantic_Canary',
    description: 'Display name for the Atlantic/Canary timezone',
    defaultMessage: 'Atlantic - Canary',
  }),
  'Atlantic/Cape_Verde': message({
    id: 'sail_timezones.timezone.Atlantic_Cape_Verde',
    description: 'Display name for the Atlantic/Cape_Verde timezone',
    defaultMessage: 'Atlantic - Cape Verde',
  }),
  'Atlantic/Faeroe': message({
    id: 'sail_timezones.timezone.Atlantic_Faeroe',
    description: 'Display name for the Atlantic/Faeroe timezone',
    defaultMessage: 'Atlantic - Faeroe',
  }),
  'Atlantic/Faroe': message({
    id: 'sail_timezones.timezone.Atlantic_Faroe',
    description: 'Display name for the Atlantic/Faroe timezone',
    defaultMessage: 'Atlantic - Faroe',
  }),
  'Atlantic/Jan_Mayen': message({
    id: 'sail_timezones.timezone.Atlantic_Jan_Mayen',
    description: 'Display name for the Atlantic/Jan_Mayen timezone',
    defaultMessage: 'Atlantic - Jan Mayen',
  }),
  'Atlantic/Madeira': message({
    id: 'sail_timezones.timezone.Atlantic_Madeira',
    description: 'Display name for the Atlantic/Madeira timezone',
    defaultMessage: 'Atlantic - Madeira',
  }),
  'Atlantic/Reykjavik': message({
    id: 'sail_timezones.timezone.Atlantic_Reykjavik',
    description: 'Display name for the Atlantic/Reykjavik timezone',
    defaultMessage: 'Atlantic - Reykjavik',
  }),
  'Atlantic/South_Georgia': message({
    id: 'sail_timezones.timezone.Atlantic_South_Georgia',
    description: 'Display name for the Atlantic/South_Georgia timezone',
    defaultMessage: 'Atlantic - South Georgia',
  }),
  'Atlantic/St_Helena': message({
    id: 'sail_timezones.timezone.Atlantic_St_Helena',
    description: 'Display name for the Atlantic/St_Helena timezone',
    defaultMessage: 'Atlantic - St Helena',
  }),
  'Atlantic/Stanley': message({
    id: 'sail_timezones.timezone.Atlantic_Stanley',
    description: 'Display name for the Atlantic/Stanley timezone',
    defaultMessage: 'Atlantic - Stanley',
  }),
  'Australia/ACT': message({
    id: 'sail_timezones.timezone.Australia_ACT',
    description: 'Display name for the Australia/ACT timezone',
    defaultMessage: 'Australia - ACT',
  }),
  'Australia/Adelaide': message({
    id: 'sail_timezones.timezone.Australia_Adelaide',
    description: 'Display name for the Australia/Adelaide timezone',
    defaultMessage: 'Australia - Adelaide',
  }),
  'Australia/Brisbane': message({
    id: 'sail_timezones.timezone.Australia_Brisbane',
    description: 'Display name for the Australia/Brisbane timezone',
    defaultMessage: 'Australia - Brisbane',
  }),
  'Australia/Broken_Hill': message({
    id: 'sail_timezones.timezone.Australia_Broken_Hill',
    description: 'Display name for the Australia/Broken_Hill timezone',
    defaultMessage: 'Australia - Broken Hill',
  }),
  'Australia/Canberra': message({
    id: 'sail_timezones.timezone.Australia_Canberra',
    description: 'Display name for the Australia/Canberra timezone',
    defaultMessage: 'Australia - Canberra',
  }),
  'Australia/Currie': message({
    id: 'sail_timezones.timezone.Australia_Currie',
    description: 'Display name for the Australia/Currie timezone',
    defaultMessage: 'Australia - Currie',
  }),
  'Australia/Darwin': message({
    id: 'sail_timezones.timezone.Australia_Darwin',
    description: 'Display name for the Australia/Darwin timezone',
    defaultMessage: 'Australia - Darwin',
  }),
  'Australia/Eucla': message({
    id: 'sail_timezones.timezone.Australia_Eucla',
    description: 'Display name for the Australia/Eucla timezone',
    defaultMessage: 'Australia - Eucla',
  }),
  'Australia/Hobart': message({
    id: 'sail_timezones.timezone.Australia_Hobart',
    description: 'Display name for the Australia/Hobart timezone',
    defaultMessage: 'Australia - Hobart',
  }),
  'Australia/LHI': message({
    id: 'sail_timezones.timezone.Australia_LHI',
    description: 'Display name for the Australia/LHI timezone',
    defaultMessage: 'Australia - LHI',
  }),
  'Australia/Lindeman': message({
    id: 'sail_timezones.timezone.Australia_Lindeman',
    description: 'Display name for the Australia/Lindeman timezone',
    defaultMessage: 'Australia - Lindeman',
  }),
  'Australia/Lord_Howe': message({
    id: 'sail_timezones.timezone.Australia_Lord_Howe',
    description: 'Display name for the Australia/Lord_Howe timezone',
    defaultMessage: 'Australia - Lord Howe',
  }),
  'Australia/Melbourne': message({
    id: 'sail_timezones.timezone.Australia_Melbourne',
    description: 'Display name for the Australia/Melbourne timezone',
    defaultMessage: 'Australia - Melbourne',
  }),
  'Australia/NSW': message({
    id: 'sail_timezones.timezone.Australia_NSW',
    description: 'Display name for the Australia/NSW timezone',
    defaultMessage: 'Australia - NSW',
  }),
  'Australia/North': message({
    id: 'sail_timezones.timezone.Australia_North',
    description: 'Display name for the Australia/North timezone',
    defaultMessage: 'Australia - North',
  }),
  'Australia/Perth': message({
    id: 'sail_timezones.timezone.Australia_Perth',
    description: 'Display name for the Australia/Perth timezone',
    defaultMessage: 'Australia - Perth',
  }),
  'Australia/Queensland': message({
    id: 'sail_timezones.timezone.Australia_Queensland',
    description: 'Display name for the Australia/Queensland timezone',
    defaultMessage: 'Australia - Queensland',
  }),
  'Australia/South': message({
    id: 'sail_timezones.timezone.Australia_South',
    description: 'Display name for the Australia/South timezone',
    defaultMessage: 'Australia - South',
  }),
  'Australia/Sydney': message({
    id: 'sail_timezones.timezone.Australia_Sydney',
    description: 'Display name for the Australia/Sydney timezone',
    defaultMessage: 'Australia - Sydney',
  }),
  'Australia/Tasmania': message({
    id: 'sail_timezones.timezone.Australia_Tasmania',
    description: 'Display name for the Australia/Tasmania timezone',
    defaultMessage: 'Australia - Tasmania',
  }),
  'Australia/Victoria': message({
    id: 'sail_timezones.timezone.Australia_Victoria',
    description: 'Display name for the Australia/Victoria timezone',
    defaultMessage: 'Australia - Victoria',
  }),
  'Australia/West': message({
    id: 'sail_timezones.timezone.Australia_West',
    description: 'Display name for the Australia/West timezone',
    defaultMessage: 'Australia - West',
  }),
  'Australia/Yancowinna': message({
    id: 'sail_timezones.timezone.Australia_Yancowinna',
    description: 'Display name for the Australia/Yancowinna timezone',
    defaultMessage: 'Australia - Yancowinna',
  }),
  'Brazil/Acre': message({
    id: 'sail_timezones.timezone.Brazil_Acre',
    description: 'Display name for the Brazil/Acre timezone',
    defaultMessage: 'Brazil - Acre',
  }),
  'Brazil/DeNoronha': message({
    id: 'sail_timezones.timezone.Brazil_DeNoronha',
    description: 'Display name for the Brazil/DeNoronha timezone',
    defaultMessage: 'Brazil - De Noronha',
  }),
  'Brazil/East': message({
    id: 'sail_timezones.timezone.Brazil_East',
    description: 'Display name for the Brazil/East timezone',
    defaultMessage: 'Brazil - East',
  }),
  'Brazil/West': message({
    id: 'sail_timezones.timezone.Brazil_West',
    description: 'Display name for the Brazil/West timezone',
    defaultMessage: 'Brazil - West',
  }),
  CET: message({
    id: 'sail_timezones.timezone.CET',
    description: 'Display name for the CET timezone',
    defaultMessage: 'CET',
  }),
  CST6CDT: message({
    id: 'sail_timezones.timezone.CST6CDT',
    description: 'Display name for the CST6CDT timezone',
    defaultMessage: 'CST6CDT',
  }),
  'Canada/Atlantic': message({
    id: 'sail_timezones.timezone.Canada_Atlantic',
    description: 'Display name for the Canada/Atlantic timezone',
    defaultMessage: 'Canada - Atlantic',
  }),
  'Canada/Central': message({
    id: 'sail_timezones.timezone.Canada_Central',
    description: 'Display name for the Canada/Central timezone',
    defaultMessage: 'Canada - Central',
  }),
  'Canada/Eastern': message({
    id: 'sail_timezones.timezone.Canada_Eastern',
    description: 'Display name for the Canada/Eastern timezone',
    defaultMessage: 'Canada - Eastern',
  }),
  'Canada/Mountain': message({
    id: 'sail_timezones.timezone.Canada_Mountain',
    description: 'Display name for the Canada/Mountain timezone',
    defaultMessage: 'Canada - Mountain',
  }),
  'Canada/Newfoundland': message({
    id: 'sail_timezones.timezone.Canada_Newfoundland',
    description: 'Display name for the Canada/Newfoundland timezone',
    defaultMessage: 'Canada - Newfoundland',
  }),
  'Canada/Pacific': message({
    id: 'sail_timezones.timezone.Canada_Pacific',
    description: 'Display name for the Canada/Pacific timezone',
    defaultMessage: 'Canada - Pacific',
  }),
  'Canada/Saskatchewan': message({
    id: 'sail_timezones.timezone.Canada_Saskatchewan',
    description: 'Display name for the Canada/Saskatchewan timezone',
    defaultMessage: 'Canada - Saskatchewan',
  }),
  'Canada/Yukon': message({
    id: 'sail_timezones.timezone.Canada_Yukon',
    description: 'Display name for the Canada/Yukon timezone',
    defaultMessage: 'Canada - Yukon',
  }),
  'Chile/Continental': message({
    id: 'sail_timezones.timezone.Chile_Continental',
    description: 'Display name for the Chile/Continental timezone',
    defaultMessage: 'Chile - Continental',
  }),
  'Chile/EasterIsland': message({
    id: 'sail_timezones.timezone.Chile_EasterIsland',
    description: 'Display name for the Chile/EasterIsland timezone',
    defaultMessage: 'Chile - Easter Island',
  }),
  Cuba: message({
    id: 'sail_timezones.timezone.Cuba',
    description: 'Display name for the Cuba timezone',
    defaultMessage: 'Cuba',
  }),
  EET: message({
    id: 'sail_timezones.timezone.EET',
    description: 'Display name for the EET timezone',
    defaultMessage: 'EET',
  }),
  EST: message({
    id: 'sail_timezones.timezone.EST',
    description: 'Display name for the EST timezone',
    defaultMessage: 'EST',
  }),
  EST5EDT: message({
    id: 'sail_timezones.timezone.EST5EDT',
    description: 'Display name for the EST5EDT timezone',
    defaultMessage: 'Eastern Time (EST / EDT)',
  }),
  Egypt: message({
    id: 'sail_timezones.timezone.Egypt',
    description: 'Display name for the Egypt timezone',
    defaultMessage: 'Egypt',
  }),
  Eire: message({
    id: 'sail_timezones.timezone.Eire',
    description: 'Display name for the Eire timezone',
    defaultMessage: 'Eire',
  }),
  'Etc/GMT': message({
    id: 'sail_timezones.timezone.Etc_GMT',
    description: 'Display name for the Etc/GMT timezone',
    defaultMessage: 'Etc/GMT (UTC+0)',
  }),
  'Etc/GMT+0': message({
    id: 'sail_timezones.timezone.Etc_GMT+0',
    description: 'Display name for the Etc/GMT+0 timezone',
    defaultMessage: 'Etc/GMT+0 (UTC+0)',
  }),
  'Etc/GMT+1': message({
    id: 'sail_timezones.timezone.Etc_GMT+1',
    description: 'Display name for the Etc/GMT+1 timezone',
    defaultMessage: 'Etc/GMT+1 (UTC-1)',
  }),
  'Etc/GMT+10': message({
    id: 'sail_timezones.timezone.Etc_GMT+10',
    description: 'Display name for the Etc/GMT+10 timezone',
    defaultMessage: 'Etc/GMT+10 (UTC-10)',
  }),
  'Etc/GMT+11': message({
    id: 'sail_timezones.timezone.Etc_GMT+11',
    description: 'Display name for the Etc/GMT+11 timezone',
    defaultMessage: 'Etc/GMT+11 (UTC-11)',
  }),
  'Etc/GMT+12': message({
    id: 'sail_timezones.timezone.Etc_GMT+12',
    description: 'Display name for the Etc/GMT+12 timezone',
    defaultMessage: 'Etc/GMT+12 (UTC-12)',
  }),
  'Etc/GMT+2': message({
    id: 'sail_timezones.timezone.Etc_GMT+2',
    description: 'Display name for the Etc/GMT+2 timezone',
    defaultMessage: 'Etc/GMT+2 (UTC-2)',
  }),
  'Etc/GMT+3': message({
    id: 'sail_timezones.timezone.Etc_GMT+3',
    description: 'Display name for the Etc/GMT+3 timezone',
    defaultMessage: 'Etc/GMT+3 (UTC-3)',
  }),
  'Etc/GMT+4': message({
    id: 'sail_timezones.timezone.Etc_GMT+4',
    description: 'Display name for the Etc/GMT+4 timezone',
    defaultMessage: 'Etc/GMT+4 (UTC-4)',
  }),
  'Etc/GMT+5': message({
    id: 'sail_timezones.timezone.Etc_GMT+5',
    description: 'Display name for the Etc/GMT+5 timezone',
    defaultMessage: 'Etc/GMT+5 (UTC-5)',
  }),
  'Etc/GMT+6': message({
    id: 'sail_timezones.timezone.Etc_GMT+6',
    description: 'Display name for the Etc/GMT+6 timezone',
    defaultMessage: 'Etc/GMT+6 (UTC-6)',
  }),
  'Etc/GMT+7': message({
    id: 'sail_timezones.timezone.Etc_GMT+7',
    description: 'Display name for the Etc/GMT+7 timezone',
    defaultMessage: 'Etc/GMT+7 (UTC-7)',
  }),
  'Etc/GMT+8': message({
    id: 'sail_timezones.timezone.Etc_GMT+8',
    description: 'Display name for the Etc/GMT+8 timezone',
    defaultMessage: 'Etc/GMT+8 (UTC-8)',
  }),
  'Etc/GMT+9': message({
    id: 'sail_timezones.timezone.Etc_GMT+9',
    description: 'Display name for the Etc/GMT+9 timezone',
    defaultMessage: 'Etc/GMT+9 (UTC-9)',
  }),
  'Etc/GMT-0': message({
    id: 'sail_timezones.timezone.Etc_GMT-0',
    description: 'Display name for the Etc/GMT-0 timezone',
    defaultMessage: 'Etc/GMT-0 (UTC+0)',
  }),
  'Etc/GMT-1': message({
    id: 'sail_timezones.timezone.Etc_GMT-1',
    description: 'Display name for the Etc/GMT-1 timezone',
    defaultMessage: 'Etc/GMT-1 (UTC+1)',
  }),
  'Etc/GMT-10': message({
    id: 'sail_timezones.timezone.Etc_GMT-10',
    description: 'Display name for the Etc/GMT-10 timezone',
    defaultMessage: 'Etc/GMT-10 (UTC+10)',
  }),
  'Etc/GMT-11': message({
    id: 'sail_timezones.timezone.Etc_GMT-11',
    description: 'Display name for the Etc/GMT-11 timezone',
    defaultMessage: 'Etc/GMT-11 (UTC+11)',
  }),
  'Etc/GMT-12': message({
    id: 'sail_timezones.timezone.Etc_GMT-12',
    description: 'Display name for the Etc/GMT-12 timezone',
    defaultMessage: 'Etc/GMT-12 (UTC+12)',
  }),
  'Etc/GMT-13': message({
    id: 'sail_timezones.timezone.Etc_GMT-13',
    description: 'Display name for the Etc/GMT-13 timezone',
    defaultMessage: 'Etc/GMT-13 (UTC+13)',
  }),
  'Etc/GMT-14': message({
    id: 'sail_timezones.timezone.Etc_GMT-14',
    description: 'Display name for the Etc/GMT-14 timezone',
    defaultMessage: 'Etc/GMT-14 (UTC+14)',
  }),
  'Etc/GMT-2': message({
    id: 'sail_timezones.timezone.Etc_GMT-2',
    description: 'Display name for the Etc/GMT-2 timezone',
    defaultMessage: 'Etc/GMT-2 (UTC+2)',
  }),
  'Etc/GMT-3': message({
    id: 'sail_timezones.timezone.Etc_GMT-3',
    description: 'Display name for the Etc/GMT-3 timezone',
    defaultMessage: 'Etc/GMT-3 (UTC+3)',
  }),
  'Etc/GMT-4': message({
    id: 'sail_timezones.timezone.Etc_GMT-4',
    description: 'Display name for the Etc/GMT-4 timezone',
    defaultMessage: 'Etc/GMT-4 (UTC+4)',
  }),
  'Etc/GMT-5': message({
    id: 'sail_timezones.timezone.Etc_GMT-5',
    description: 'Display name for the Etc/GMT-5 timezone',
    defaultMessage: 'Etc/GMT-5 (UTC+5)',
  }),
  'Etc/GMT-6': message({
    id: 'sail_timezones.timezone.Etc_GMT-6',
    description: 'Display name for the Etc/GMT-6 timezone',
    defaultMessage: 'Etc/GMT-6 (UTC+6)',
  }),
  'Etc/GMT-7': message({
    id: 'sail_timezones.timezone.Etc_GMT-7',
    description: 'Display name for the Etc/GMT-7 timezone',
    defaultMessage: 'Etc/GMT-7 (UTC+7)',
  }),
  'Etc/GMT-8': message({
    id: 'sail_timezones.timezone.Etc_GMT-8',
    description: 'Display name for the Etc/GMT-8 timezone',
    defaultMessage: 'Etc/GMT-8 (UTC+8)',
  }),
  'Etc/GMT-9': message({
    id: 'sail_timezones.timezone.Etc_GMT-9',
    description: 'Display name for the Etc/GMT-9 timezone',
    defaultMessage: 'Etc/GMT-9 (UTC+9)',
  }),
  'Etc/GMT0': message({
    id: 'sail_timezones.timezone.Etc_GMT0',
    description: 'Display name for the Etc/GMT0 timezone',
    defaultMessage: 'Etc/GMT0 (UTC+0)',
  }),
  'Etc/Greenwich': message({
    id: 'sail_timezones.timezone.Etc_Greenwich',
    description: 'Display name for the Etc/Greenwich timezone',
    defaultMessage: 'Etc - Greenwich',
  }),
  'Etc/UCT': message({
    id: 'sail_timezones.timezone.Etc_UCT',
    description: 'Display name for the Etc/UCT timezone',
    defaultMessage: 'Etc - UCT',
  }),
  'Etc/UTC': message({
    id: 'sail_timezones.timezone.Etc_UTC',
    description: 'Display name for the Etc/UTC timezone',
    defaultMessage: 'Etc - UTC',
  }),
  'Etc/Universal': message({
    id: 'sail_timezones.timezone.Etc_Universal',
    description: 'Display name for the Etc/Universal timezone',
    defaultMessage: 'Etc - Universal',
  }),
  'Etc/Zulu': message({
    id: 'sail_timezones.timezone.Etc_Zulu',
    description: 'Display name for the Etc/Zulu timezone',
    defaultMessage: 'Etc - Zulu',
  }),
  'Europe/Amsterdam': message({
    id: 'sail_timezones.timezone.Europe_Amsterdam',
    description: 'Display name for the Europe/Amsterdam timezone',
    defaultMessage: 'Europe - Amsterdam',
  }),
  'Europe/Andorra': message({
    id: 'sail_timezones.timezone.Europe_Andorra',
    description: 'Display name for the Europe/Andorra timezone',
    defaultMessage: 'Europe - Andorra',
  }),
  'Europe/Astrakhan': message({
    id: 'sail_timezones.timezone.Europe_Astrakhan',
    description: 'Display name for the Europe/Astrakhan timezone',
    defaultMessage: 'Europe - Astrakhan',
  }),
  'Europe/Athens': message({
    id: 'sail_timezones.timezone.Europe_Athens',
    description: 'Display name for the Europe/Athens timezone',
    defaultMessage: 'Europe - Athens',
  }),
  'Europe/Belfast': message({
    id: 'sail_timezones.timezone.Europe_Belfast',
    description: 'Display name for the Europe/Belfast timezone',
    defaultMessage: 'Europe - Belfast',
  }),
  'Europe/Belgrade': message({
    id: 'sail_timezones.timezone.Europe_Belgrade',
    description: 'Display name for the Europe/Belgrade timezone',
    defaultMessage: 'Europe - Belgrade',
  }),
  'Europe/Berlin': message({
    id: 'sail_timezones.timezone.Europe_Berlin',
    description: 'Display name for the Europe/Berlin timezone',
    defaultMessage: 'Europe - Berlin',
  }),
  'Europe/Bratislava': message({
    id: 'sail_timezones.timezone.Europe_Bratislava',
    description: 'Display name for the Europe/Bratislava timezone',
    defaultMessage: 'Europe - Bratislava',
  }),
  'Europe/Brussels': message({
    id: 'sail_timezones.timezone.Europe_Brussels',
    description: 'Display name for the Europe/Brussels timezone',
    defaultMessage: 'Europe - Brussels',
  }),
  'Europe/Bucharest': message({
    id: 'sail_timezones.timezone.Europe_Bucharest',
    description: 'Display name for the Europe/Bucharest timezone',
    defaultMessage: 'Europe - Bucharest',
  }),
  'Europe/Budapest': message({
    id: 'sail_timezones.timezone.Europe_Budapest',
    description: 'Display name for the Europe/Budapest timezone',
    defaultMessage: 'Europe - Budapest',
  }),
  'Europe/Busingen': message({
    id: 'sail_timezones.timezone.Europe_Busingen',
    description: 'Display name for the Europe/Busingen timezone',
    defaultMessage: 'Europe - Busingen',
  }),
  'Europe/Chisinau': message({
    id: 'sail_timezones.timezone.Europe_Chisinau',
    description: 'Display name for the Europe/Chisinau timezone',
    defaultMessage: 'Europe - Chisinau',
  }),
  'Europe/Copenhagen': message({
    id: 'sail_timezones.timezone.Europe_Copenhagen',
    description: 'Display name for the Europe/Copenhagen timezone',
    defaultMessage: 'Europe - Copenhagen',
  }),
  'Europe/Dublin': message({
    id: 'sail_timezones.timezone.Europe_Dublin',
    description: 'Display name for the Europe/Dublin timezone',
    defaultMessage: 'Europe - Dublin',
  }),
  'Europe/Gibraltar': message({
    id: 'sail_timezones.timezone.Europe_Gibraltar',
    description: 'Display name for the Europe/Gibraltar timezone',
    defaultMessage: 'Europe - Gibraltar',
  }),
  'Europe/Guernsey': message({
    id: 'sail_timezones.timezone.Europe_Guernsey',
    description: 'Display name for the Europe/Guernsey timezone',
    defaultMessage: 'Europe - Guernsey',
  }),
  'Europe/Helsinki': message({
    id: 'sail_timezones.timezone.Europe_Helsinki',
    description: 'Display name for the Europe/Helsinki timezone',
    defaultMessage: 'Europe - Helsinki',
  }),
  'Europe/Isle_of_Man': message({
    id: 'sail_timezones.timezone.Europe_Isle_of_Man',
    description: 'Display name for the Europe/Isle_of_Man timezone',
    defaultMessage: 'Europe - Isle of Man',
  }),
  'Europe/Istanbul': message({
    id: 'sail_timezones.timezone.Europe_Istanbul',
    description: 'Display name for the Europe/Istanbul timezone',
    defaultMessage: 'Europe - Istanbul',
  }),
  'Europe/Jersey': message({
    id: 'sail_timezones.timezone.Europe_Jersey',
    description: 'Display name for the Europe/Jersey timezone',
    defaultMessage: 'Europe - Jersey',
  }),
  'Europe/Kaliningrad': message({
    id: 'sail_timezones.timezone.Europe_Kaliningrad',
    description: 'Display name for the Europe/Kaliningrad timezone',
    defaultMessage: 'Europe - Kaliningrad',
  }),
  'Europe/Kiev': message({
    id: 'sail_timezones.timezone.Europe_Kiev',
    description: 'Display name for the Europe/Kiev timezone',
    defaultMessage: 'Europe - Kiev',
  }),
  'Europe/Kirov': message({
    id: 'sail_timezones.timezone.Europe_Kirov',
    description: 'Display name for the Europe/Kirov timezone',
    defaultMessage: 'Europe - Kirov',
  }),
  'Europe/Lisbon': message({
    id: 'sail_timezones.timezone.Europe_Lisbon',
    description: 'Display name for the Europe/Lisbon timezone',
    defaultMessage: 'Europe - Lisbon',
  }),
  'Europe/Ljubljana': message({
    id: 'sail_timezones.timezone.Europe_Ljubljana',
    description: 'Display name for the Europe/Ljubljana timezone',
    defaultMessage: 'Europe - Ljubljana',
  }),
  'Europe/London': message({
    id: 'sail_timezones.timezone.Europe_London',
    description: 'Display name for the Europe/London timezone',
    defaultMessage: 'Europe - London',
  }),
  'Europe/Luxembourg': message({
    id: 'sail_timezones.timezone.Europe_Luxembourg',
    description: 'Display name for the Europe/Luxembourg timezone',
    defaultMessage: 'Europe - Luxembourg',
  }),
  'Europe/Madrid': message({
    id: 'sail_timezones.timezone.Europe_Madrid',
    description: 'Display name for the Europe/Madrid timezone',
    defaultMessage: 'Europe - Madrid',
  }),
  'Europe/Malta': message({
    id: 'sail_timezones.timezone.Europe_Malta',
    description: 'Display name for the Europe/Malta timezone',
    defaultMessage: 'Europe - Malta',
  }),
  'Europe/Mariehamn': message({
    id: 'sail_timezones.timezone.Europe_Mariehamn',
    description: 'Display name for the Europe/Mariehamn timezone',
    defaultMessage: 'Europe - Mariehamn',
  }),
  'Europe/Minsk': message({
    id: 'sail_timezones.timezone.Europe_Minsk',
    description: 'Display name for the Europe/Minsk timezone',
    defaultMessage: 'Europe - Minsk',
  }),
  'Europe/Monaco': message({
    id: 'sail_timezones.timezone.Europe_Monaco',
    description: 'Display name for the Europe/Monaco timezone',
    defaultMessage: 'Europe - Monaco',
  }),
  'Europe/Moscow': message({
    id: 'sail_timezones.timezone.Europe_Moscow',
    description: 'Display name for the Europe/Moscow timezone',
    defaultMessage: 'Europe - Moscow',
  }),
  'Europe/Nicosia': message({
    id: 'sail_timezones.timezone.Europe_Nicosia',
    description: 'Display name for the Europe/Nicosia timezone',
    defaultMessage: 'Europe - Nicosia',
  }),
  'Europe/Oslo': message({
    id: 'sail_timezones.timezone.Europe_Oslo',
    description: 'Display name for the Europe/Oslo timezone',
    defaultMessage: 'Europe - Oslo',
  }),
  'Europe/Paris': message({
    id: 'sail_timezones.timezone.Europe_Paris',
    description: 'Display name for the Europe/Paris timezone',
    defaultMessage: 'Europe - Paris',
  }),
  'Europe/Podgorica': message({
    id: 'sail_timezones.timezone.Europe_Podgorica',
    description: 'Display name for the Europe/Podgorica timezone',
    defaultMessage: 'Europe - Podgorica',
  }),
  'Europe/Prague': message({
    id: 'sail_timezones.timezone.Europe_Prague',
    description: 'Display name for the Europe/Prague timezone',
    defaultMessage: 'Europe - Prague',
  }),
  'Europe/Riga': message({
    id: 'sail_timezones.timezone.Europe_Riga',
    description: 'Display name for the Europe/Riga timezone',
    defaultMessage: 'Europe - Riga',
  }),
  'Europe/Rome': message({
    id: 'sail_timezones.timezone.Europe_Rome',
    description: 'Display name for the Europe/Rome timezone',
    defaultMessage: 'Europe - Rome',
  }),
  'Europe/Samara': message({
    id: 'sail_timezones.timezone.Europe_Samara',
    description: 'Display name for the Europe/Samara timezone',
    defaultMessage: 'Europe - Samara',
  }),
  'Europe/San_Marino': message({
    id: 'sail_timezones.timezone.Europe_San_Marino',
    description: 'Display name for the Europe/San_Marino timezone',
    defaultMessage: 'Europe - San Marino',
  }),
  'Europe/Sarajevo': message({
    id: 'sail_timezones.timezone.Europe_Sarajevo',
    description: 'Display name for the Europe/Sarajevo timezone',
    defaultMessage: 'Europe - Sarajevo',
  }),
  'Europe/Saratov': message({
    id: 'sail_timezones.timezone.Europe_Saratov',
    description: 'Display name for the Europe/Saratov timezone',
    defaultMessage: 'Europe - Saratov',
  }),
  'Europe/Simferopol': message({
    id: 'sail_timezones.timezone.Europe_Simferopol',
    description: 'Display name for the Europe/Simferopol timezone',
    defaultMessage: 'Europe - Simferopol',
  }),
  'Europe/Skopje': message({
    id: 'sail_timezones.timezone.Europe_Skopje',
    description: 'Display name for the Europe/Skopje timezone',
    defaultMessage: 'Europe - Skopje',
  }),
  'Europe/Sofia': message({
    id: 'sail_timezones.timezone.Europe_Sofia',
    description: 'Display name for the Europe/Sofia timezone',
    defaultMessage: 'Europe - Sofia',
  }),
  'Europe/Stockholm': message({
    id: 'sail_timezones.timezone.Europe_Stockholm',
    description: 'Display name for the Europe/Stockholm timezone',
    defaultMessage: 'Europe - Stockholm',
  }),
  'Europe/Tallinn': message({
    id: 'sail_timezones.timezone.Europe_Tallinn',
    description: 'Display name for the Europe/Tallinn timezone',
    defaultMessage: 'Europe - Tallinn',
  }),
  'Europe/Tirane': message({
    id: 'sail_timezones.timezone.Europe_Tirane',
    description: 'Display name for the Europe/Tirane timezone',
    defaultMessage: 'Europe - Tirane',
  }),
  'Europe/Tiraspol': message({
    id: 'sail_timezones.timezone.Europe_Tiraspol',
    description: 'Display name for the Europe/Tiraspol timezone',
    defaultMessage: 'Europe - Tiraspol',
  }),
  'Europe/Ulyanovsk': message({
    id: 'sail_timezones.timezone.Europe_Ulyanovsk',
    description: 'Display name for the Europe/Ulyanovsk timezone',
    defaultMessage: 'Europe - Ulyanovsk',
  }),
  'Europe/Uzhgorod': message({
    id: 'sail_timezones.timezone.Europe_Uzhgorod',
    description: 'Display name for the Europe/Uzhgorod timezone',
    defaultMessage: 'Europe - Uzhgorod',
  }),
  'Europe/Vaduz': message({
    id: 'sail_timezones.timezone.Europe_Vaduz',
    description: 'Display name for the Europe/Vaduz timezone',
    defaultMessage: 'Europe - Vaduz',
  }),
  'Europe/Vatican': message({
    id: 'sail_timezones.timezone.Europe_Vatican',
    description: 'Display name for the Europe/Vatican timezone',
    defaultMessage: 'Europe - Vatican',
  }),
  'Europe/Vienna': message({
    id: 'sail_timezones.timezone.Europe_Vienna',
    description: 'Display name for the Europe/Vienna timezone',
    defaultMessage: 'Europe - Vienna',
  }),
  'Europe/Vilnius': message({
    id: 'sail_timezones.timezone.Europe_Vilnius',
    description: 'Display name for the Europe/Vilnius timezone',
    defaultMessage: 'Europe - Vilnius',
  }),
  'Europe/Volgograd': message({
    id: 'sail_timezones.timezone.Europe_Volgograd',
    description: 'Display name for the Europe/Volgograd timezone',
    defaultMessage: 'Europe - Volgograd',
  }),
  'Europe/Warsaw': message({
    id: 'sail_timezones.timezone.Europe_Warsaw',
    description: 'Display name for the Europe/Warsaw timezone',
    defaultMessage: 'Europe - Warsaw',
  }),
  'Europe/Zagreb': message({
    id: 'sail_timezones.timezone.Europe_Zagreb',
    description: 'Display name for the Europe/Zagreb timezone',
    defaultMessage: 'Europe - Zagreb',
  }),
  'Europe/Zaporozhye': message({
    id: 'sail_timezones.timezone.Europe_Zaporozhye',
    description: 'Display name for the Europe/Zaporozhye timezone',
    defaultMessage: 'Europe - Zaporozhye',
  }),
  'Europe/Zurich': message({
    id: 'sail_timezones.timezone.Europe_Zurich',
    description: 'Display name for the Europe/Zurich timezone',
    defaultMessage: 'Europe - Zurich',
  }),
  Factory: message({
    id: 'sail_timezones.timezone.Factory',
    description: 'Display name for the Factory timezone',
    defaultMessage: 'Factory',
  }),
  GB: message({
    id: 'sail_timezones.timezone.GB',
    description: 'Display name for the GB timezone',
    defaultMessage: 'GB',
  }),
  'GB-Eire': message({
    id: 'sail_timezones.timezone.GB-Eire',
    description: 'Display name for the GB-Eire timezone',
    defaultMessage: 'GB-Eire',
  }),
  GMT: message({
    id: 'sail_timezones.timezone.GMT',
    description: 'Display name for the GMT timezone',
    defaultMessage: 'GMT',
  }),
  'GMT+0': message({
    id: 'sail_timezones.timezone.GMT+0',
    description: 'Display name for the GMT+0 timezone',
    defaultMessage: 'GMT+0',
  }),
  'GMT-0': message({
    id: 'sail_timezones.timezone.GMT-0',
    description: 'Display name for the GMT-0 timezone',
    defaultMessage: 'GMT-0',
  }),
  GMT0: message({
    id: 'sail_timezones.timezone.GMT0',
    description: 'Display name for the GMT0 timezone',
    defaultMessage: 'GMT0',
  }),
  Greenwich: message({
    id: 'sail_timezones.timezone.Greenwich',
    description: 'Display name for the Greenwich timezone',
    defaultMessage: 'Greenwich',
  }),
  HST: message({
    id: 'sail_timezones.timezone.HST',
    description: 'Display name for the HST timezone',
    defaultMessage: 'HST',
  }),
  Hongkong: message({
    id: 'sail_timezones.timezone.Hongkong',
    description: 'Display name for the Hongkong timezone',
    defaultMessage: 'Hongkong',
  }),
  Iceland: message({
    id: 'sail_timezones.timezone.Iceland',
    description: 'Display name for the Iceland timezone',
    defaultMessage: 'Iceland',
  }),
  'Indian/Antananarivo': message({
    id: 'sail_timezones.timezone.Indian_Antananarivo',
    description: 'Display name for the Indian/Antananarivo timezone',
    defaultMessage: 'Indian - Antananarivo',
  }),
  'Indian/Chagos': message({
    id: 'sail_timezones.timezone.Indian_Chagos',
    description: 'Display name for the Indian/Chagos timezone',
    defaultMessage: 'Indian - Chagos',
  }),
  'Indian/Christmas': message({
    id: 'sail_timezones.timezone.Indian_Christmas',
    description: 'Display name for the Indian/Christmas timezone',
    defaultMessage: 'Indian - Christmas',
  }),
  'Indian/Cocos': message({
    id: 'sail_timezones.timezone.Indian_Cocos',
    description: 'Display name for the Indian/Cocos timezone',
    defaultMessage: 'Indian - Cocos',
  }),
  'Indian/Comoro': message({
    id: 'sail_timezones.timezone.Indian_Comoro',
    description: 'Display name for the Indian/Comoro timezone',
    defaultMessage: 'Indian - Comoro',
  }),
  'Indian/Kerguelen': message({
    id: 'sail_timezones.timezone.Indian_Kerguelen',
    description: 'Display name for the Indian/Kerguelen timezone',
    defaultMessage: 'Indian - Kerguelen',
  }),
  'Indian/Mahe': message({
    id: 'sail_timezones.timezone.Indian_Mahe',
    description: 'Display name for the Indian/Mahe timezone',
    defaultMessage: 'Indian - Mahe',
  }),
  'Indian/Maldives': message({
    id: 'sail_timezones.timezone.Indian_Maldives',
    description: 'Display name for the Indian/Maldives timezone',
    defaultMessage: 'Indian - Maldives',
  }),
  'Indian/Mauritius': message({
    id: 'sail_timezones.timezone.Indian_Mauritius',
    description: 'Display name for the Indian/Mauritius timezone',
    defaultMessage: 'Indian - Mauritius',
  }),
  'Indian/Mayotte': message({
    id: 'sail_timezones.timezone.Indian_Mayotte',
    description: 'Display name for the Indian/Mayotte timezone',
    defaultMessage: 'Indian - Mayotte',
  }),
  'Indian/Reunion': message({
    id: 'sail_timezones.timezone.Indian_Reunion',
    description: 'Display name for the Indian/Reunion timezone',
    defaultMessage: 'Indian - Reunion',
  }),
  Iran: message({
    id: 'sail_timezones.timezone.Iran',
    description: 'Display name for the Iran timezone',
    defaultMessage: 'Iran',
  }),
  Israel: message({
    id: 'sail_timezones.timezone.Israel',
    description: 'Display name for the Israel timezone',
    defaultMessage: 'Israel',
  }),
  Jamaica: message({
    id: 'sail_timezones.timezone.Jamaica',
    description: 'Display name for the Jamaica timezone',
    defaultMessage: 'Jamaica',
  }),
  Japan: message({
    id: 'sail_timezones.timezone.Japan',
    description: 'Display name for the Japan timezone',
    defaultMessage: 'Japan',
  }),
  Kwajalein: message({
    id: 'sail_timezones.timezone.Kwajalein',
    description: 'Display name for the Kwajalein timezone',
    defaultMessage: 'Kwajalein',
  }),
  Libya: message({
    id: 'sail_timezones.timezone.Libya',
    description: 'Display name for the Libya timezone',
    defaultMessage: 'Libya',
  }),
  MET: message({
    id: 'sail_timezones.timezone.MET',
    description: 'Display name for the MET timezone',
    defaultMessage: 'MET',
  }),
  MST: message({
    id: 'sail_timezones.timezone.MST',
    description: 'Display name for the MST timezone',
    defaultMessage: 'MST',
  }),
  MST7MDT: message({
    id: 'sail_timezones.timezone.MST7MDT',
    description: 'Display name for the MST7MDT timezone',
    defaultMessage: 'Mountain Time (MST / MDT)',
  }),
  'Mexico/BajaNorte': message({
    id: 'sail_timezones.timezone.Mexico_BajaNorte',
    description: 'Display name for the Mexico/BajaNorte timezone',
    defaultMessage: 'Mexico - Baja Norte',
  }),
  'Mexico/BajaSur': message({
    id: 'sail_timezones.timezone.Mexico_BajaSur',
    description: 'Display name for the Mexico/BajaSur timezone',
    defaultMessage: 'Mexico - Baja Sur',
  }),
  'Mexico/General': message({
    id: 'sail_timezones.timezone.Mexico_General',
    description: 'Display name for the Mexico/General timezone',
    defaultMessage: 'Mexico - General',
  }),
  NZ: message({
    id: 'sail_timezones.timezone.NZ',
    description: 'Display name for the NZ timezone',
    defaultMessage: 'NZ',
  }),
  'NZ-CHAT': message({
    id: 'sail_timezones.timezone.NZ-CHAT',
    description: 'Display name for the NZ-CHAT timezone',
    defaultMessage: 'NZ-CHAT',
  }),
  Navajo: message({
    id: 'sail_timezones.timezone.Navajo',
    description: 'Display name for the Navajo timezone',
    defaultMessage: 'Navajo',
  }),
  PRC: message({
    id: 'sail_timezones.timezone.PRC',
    description: 'Display name for the PRC timezone',
    defaultMessage: 'PRC',
  }),
  PST8PDT: message({
    id: 'sail_timezones.timezone.PST8PDT',
    description: 'Display name for the PST8PDT timezone',
    defaultMessage: 'Pacific Time (PST / PDT)',
  }),
  'Pacific/Apia': message({
    id: 'sail_timezones.timezone.Pacific_Apia',
    description: 'Display name for the Pacific/Apia timezone',
    defaultMessage: 'Pacific - Apia',
  }),
  'Pacific/Auckland': message({
    id: 'sail_timezones.timezone.Pacific_Auckland',
    description: 'Display name for the Pacific/Auckland timezone',
    defaultMessage: 'Pacific - Auckland',
  }),
  'Pacific/Bougainville': message({
    id: 'sail_timezones.timezone.Pacific_Bougainville',
    description: 'Display name for the Pacific/Bougainville timezone',
    defaultMessage: 'Pacific - Bougainville',
  }),
  'Pacific/Chatham': message({
    id: 'sail_timezones.timezone.Pacific_Chatham',
    description: 'Display name for the Pacific/Chatham timezone',
    defaultMessage: 'Pacific - Chatham',
  }),
  'Pacific/Chuuk': message({
    id: 'sail_timezones.timezone.Pacific_Chuuk',
    description: 'Display name for the Pacific/Chuuk timezone',
    defaultMessage: 'Pacific - Chuuk',
  }),
  'Pacific/Easter': message({
    id: 'sail_timezones.timezone.Pacific_Easter',
    description: 'Display name for the Pacific/Easter timezone',
    defaultMessage: 'Pacific - Easter',
  }),
  'Pacific/Efate': message({
    id: 'sail_timezones.timezone.Pacific_Efate',
    description: 'Display name for the Pacific/Efate timezone',
    defaultMessage: 'Pacific - Efate',
  }),
  'Pacific/Enderbury': message({
    id: 'sail_timezones.timezone.Pacific_Enderbury',
    description: 'Display name for the Pacific/Enderbury timezone',
    defaultMessage: 'Pacific - Enderbury',
  }),
  'Pacific/Fakaofo': message({
    id: 'sail_timezones.timezone.Pacific_Fakaofo',
    description: 'Display name for the Pacific/Fakaofo timezone',
    defaultMessage: 'Pacific - Fakaofo',
  }),
  'Pacific/Fiji': message({
    id: 'sail_timezones.timezone.Pacific_Fiji',
    description: 'Display name for the Pacific/Fiji timezone',
    defaultMessage: 'Pacific - Fiji',
  }),
  'Pacific/Funafuti': message({
    id: 'sail_timezones.timezone.Pacific_Funafuti',
    description: 'Display name for the Pacific/Funafuti timezone',
    defaultMessage: 'Pacific - Funafuti',
  }),
  'Pacific/Galapagos': message({
    id: 'sail_timezones.timezone.Pacific_Galapagos',
    description: 'Display name for the Pacific/Galapagos timezone',
    defaultMessage: 'Pacific - Galapagos',
  }),
  'Pacific/Gambier': message({
    id: 'sail_timezones.timezone.Pacific_Gambier',
    description: 'Display name for the Pacific/Gambier timezone',
    defaultMessage: 'Pacific - Gambier',
  }),
  'Pacific/Guadalcanal': message({
    id: 'sail_timezones.timezone.Pacific_Guadalcanal',
    description: 'Display name for the Pacific/Guadalcanal timezone',
    defaultMessage: 'Pacific - Guadalcanal',
  }),
  'Pacific/Guam': message({
    id: 'sail_timezones.timezone.Pacific_Guam',
    description: 'Display name for the Pacific/Guam timezone',
    defaultMessage: 'Pacific - Guam',
  }),
  'Pacific/Honolulu': message({
    id: 'sail_timezones.timezone.Pacific_Honolulu',
    description: 'Display name for the Pacific/Honolulu timezone',
    defaultMessage: 'Pacific - Honolulu',
  }),
  'Pacific/Johnston': message({
    id: 'sail_timezones.timezone.Pacific_Johnston',
    description: 'Display name for the Pacific/Johnston timezone',
    defaultMessage: 'Pacific - Johnston',
  }),
  'Pacific/Kiritimati': message({
    id: 'sail_timezones.timezone.Pacific_Kiritimati',
    description: 'Display name for the Pacific/Kiritimati timezone',
    defaultMessage: 'Pacific - Kiritimati',
  }),
  'Pacific/Kosrae': message({
    id: 'sail_timezones.timezone.Pacific_Kosrae',
    description: 'Display name for the Pacific/Kosrae timezone',
    defaultMessage: 'Pacific - Kosrae',
  }),
  'Pacific/Kwajalein': message({
    id: 'sail_timezones.timezone.Pacific_Kwajalein',
    description: 'Display name for the Pacific/Kwajalein timezone',
    defaultMessage: 'Pacific - Kwajalein',
  }),
  'Pacific/Majuro': message({
    id: 'sail_timezones.timezone.Pacific_Majuro',
    description: 'Display name for the Pacific/Majuro timezone',
    defaultMessage: 'Pacific - Majuro',
  }),
  'Pacific/Marquesas': message({
    id: 'sail_timezones.timezone.Pacific_Marquesas',
    description: 'Display name for the Pacific/Marquesas timezone',
    defaultMessage: 'Pacific - Marquesas',
  }),
  'Pacific/Midway': message({
    id: 'sail_timezones.timezone.Pacific_Midway',
    description: 'Display name for the Pacific/Midway timezone',
    defaultMessage: 'Pacific - Midway',
  }),
  'Pacific/Nauru': message({
    id: 'sail_timezones.timezone.Pacific_Nauru',
    description: 'Display name for the Pacific/Nauru timezone',
    defaultMessage: 'Pacific - Nauru',
  }),
  'Pacific/Niue': message({
    id: 'sail_timezones.timezone.Pacific_Niue',
    description: 'Display name for the Pacific/Niue timezone',
    defaultMessage: 'Pacific - Niue',
  }),
  'Pacific/Norfolk': message({
    id: 'sail_timezones.timezone.Pacific_Norfolk',
    description: 'Display name for the Pacific/Norfolk timezone',
    defaultMessage: 'Pacific - Norfolk',
  }),
  'Pacific/Noumea': message({
    id: 'sail_timezones.timezone.Pacific_Noumea',
    description: 'Display name for the Pacific/Noumea timezone',
    defaultMessage: 'Pacific - Noumea',
  }),
  'Pacific/Pago_Pago': message({
    id: 'sail_timezones.timezone.Pacific_Pago_Pago',
    description: 'Display name for the Pacific/Pago_Pago timezone',
    defaultMessage: 'Pacific - Pago Pago',
  }),
  'Pacific/Palau': message({
    id: 'sail_timezones.timezone.Pacific_Palau',
    description: 'Display name for the Pacific/Palau timezone',
    defaultMessage: 'Pacific - Palau',
  }),
  'Pacific/Pitcairn': message({
    id: 'sail_timezones.timezone.Pacific_Pitcairn',
    description: 'Display name for the Pacific/Pitcairn timezone',
    defaultMessage: 'Pacific - Pitcairn',
  }),
  'Pacific/Pohnpei': message({
    id: 'sail_timezones.timezone.Pacific_Pohnpei',
    description: 'Display name for the Pacific/Pohnpei timezone',
    defaultMessage: 'Pacific - Pohnpei',
  }),
  'Pacific/Ponape': message({
    id: 'sail_timezones.timezone.Pacific_Ponape',
    description: 'Display name for the Pacific/Ponape timezone',
    defaultMessage: 'Pacific - Ponape',
  }),
  'Pacific/Port_Moresby': message({
    id: 'sail_timezones.timezone.Pacific_Port_Moresby',
    description: 'Display name for the Pacific/Port_Moresby timezone',
    defaultMessage: 'Pacific - Port Moresby',
  }),
  'Pacific/Rarotonga': message({
    id: 'sail_timezones.timezone.Pacific_Rarotonga',
    description: 'Display name for the Pacific/Rarotonga timezone',
    defaultMessage: 'Pacific - Rarotonga',
  }),
  'Pacific/Saipan': message({
    id: 'sail_timezones.timezone.Pacific_Saipan',
    description: 'Display name for the Pacific/Saipan timezone',
    defaultMessage: 'Pacific - Saipan',
  }),
  'Pacific/Samoa': message({
    id: 'sail_timezones.timezone.Pacific_Samoa',
    description: 'Display name for the Pacific/Samoa timezone',
    defaultMessage: 'Pacific - Samoa',
  }),
  'Pacific/Tahiti': message({
    id: 'sail_timezones.timezone.Pacific_Tahiti',
    description: 'Display name for the Pacific/Tahiti timezone',
    defaultMessage: 'Pacific - Tahiti',
  }),
  'Pacific/Tarawa': message({
    id: 'sail_timezones.timezone.Pacific_Tarawa',
    description: 'Display name for the Pacific/Tarawa timezone',
    defaultMessage: 'Pacific - Tarawa',
  }),
  'Pacific/Tongatapu': message({
    id: 'sail_timezones.timezone.Pacific_Tongatapu',
    description: 'Display name for the Pacific/Tongatapu timezone',
    defaultMessage: 'Pacific - Tongatapu',
  }),
  'Pacific/Truk': message({
    id: 'sail_timezones.timezone.Pacific_Truk',
    description: 'Display name for the Pacific/Truk timezone',
    defaultMessage: 'Pacific - Truk',
  }),
  'Pacific/Wake': message({
    id: 'sail_timezones.timezone.Pacific_Wake',
    description: 'Display name for the Pacific/Wake timezone',
    defaultMessage: 'Pacific - Wake',
  }),
  'Pacific/Wallis': message({
    id: 'sail_timezones.timezone.Pacific_Wallis',
    description: 'Display name for the Pacific/Wallis timezone',
    defaultMessage: 'Pacific - Wallis',
  }),
  'Pacific/Yap': message({
    id: 'sail_timezones.timezone.Pacific_Yap',
    description: 'Display name for the Pacific/Yap timezone',
    defaultMessage: 'Pacific - Yap',
  }),
  Poland: message({
    id: 'sail_timezones.timezone.Poland',
    description: 'Display name for the Poland timezone',
    defaultMessage: 'Poland',
  }),
  Portugal: message({
    id: 'sail_timezones.timezone.Portugal',
    description: 'Display name for the Portugal timezone',
    defaultMessage: 'Portugal',
  }),
  ROC: message({
    id: 'sail_timezones.timezone.ROC',
    description: 'Display name for the ROC timezone',
    defaultMessage: 'ROC',
  }),
  ROK: message({
    id: 'sail_timezones.timezone.ROK',
    description: 'Display name for the ROK timezone',
    defaultMessage: 'ROK',
  }),
  Singapore: message({
    id: 'sail_timezones.timezone.Singapore',
    description: 'Display name for the Singapore timezone',
    defaultMessage: 'Singapore',
  }),
  Turkey: message({
    id: 'sail_timezones.timezone.Turkey',
    description: 'Display name for the Turkey timezone',
    defaultMessage: 'Turkey',
  }),
  UCT: message({
    id: 'sail_timezones.timezone.UCT',
    description: 'Display name for the UCT timezone',
    defaultMessage: 'UCT',
  }),
  'US/Alaska': message({
    id: 'sail_timezones.timezone.US_Alaska',
    description: 'Display name for the US/Alaska timezone',
    defaultMessage: 'US - Alaska',
  }),
  'US/Aleutian': message({
    id: 'sail_timezones.timezone.US_Aleutian',
    description: 'Display name for the US/Aleutian timezone',
    defaultMessage: 'US - Aleutian',
  }),
  'US/Arizona': message({
    id: 'sail_timezones.timezone.US_Arizona',
    description: 'Display name for the US/Arizona timezone',
    defaultMessage: 'US - Arizona',
  }),
  'US/Central': message({
    id: 'sail_timezones.timezone.US_Central',
    description: 'Display name for the US/Central timezone',
    defaultMessage: 'US - Central',
  }),
  'US/East-Indiana': message({
    id: 'sail_timezones.timezone.US_East-Indiana',
    description: 'Display name for the US/East-Indiana timezone',
    defaultMessage: 'US - East-Indiana',
  }),
  'US/Eastern': message({
    id: 'sail_timezones.timezone.US_Eastern',
    description: 'Display name for the US/Eastern timezone',
    defaultMessage: 'US - Eastern',
  }),
  'US/Hawaii': message({
    id: 'sail_timezones.timezone.US_Hawaii',
    description: 'Display name for the US/Hawaii timezone',
    defaultMessage: 'US - Hawaii',
  }),
  'US/Indiana-Starke': message({
    id: 'sail_timezones.timezone.US_Indiana-Starke',
    description: 'Display name for the US/Indiana-Starke timezone',
    defaultMessage: 'US - Indiana-Starke',
  }),
  'US/Michigan': message({
    id: 'sail_timezones.timezone.US_Michigan',
    description: 'Display name for the US/Michigan timezone',
    defaultMessage: 'US - Michigan',
  }),
  'US/Mountain': message({
    id: 'sail_timezones.timezone.US_Mountain',
    description: 'Display name for the US/Mountain timezone',
    defaultMessage: 'US - Mountain',
  }),
  'US/Pacific': message({
    id: 'sail_timezones.timezone.US_Pacific',
    description: 'Display name for the US/Pacific timezone',
    defaultMessage: 'US - Pacific',
  }),
  'US/Pacific-New': message({
    id: 'sail_timezones.timezone.US_Pacific-New',
    description: 'Display name for the US/Pacific-New timezone',
    defaultMessage: 'US - Pacific-New',
  }),
  'US/Samoa': message({
    id: 'sail_timezones.timezone.US_Samoa',
    description: 'Display name for the US/Samoa timezone',
    defaultMessage: 'US - Samoa',
  }),
  UTC: message({
    id: 'sail_timezones.timezone.UTC',
    description: 'Display name for the UTC timezone',
    defaultMessage: 'UTC',
  }),
  Universal: message({
    id: 'sail_timezones.timezone.Universal',
    description: 'Display name for the Universal timezone',
    defaultMessage: 'Universal',
  }),
  'W-SU': message({
    id: 'sail_timezones.timezone.W-SU',
    description: 'Display name for the W-SU timezone',
    defaultMessage: 'W-SU',
  }),
  WET: message({
    id: 'sail_timezones.timezone.WET',
    description: 'Display name for the WET timezone',
    defaultMessage: 'WET',
  }),
  Zulu: message({
    id: 'sail_timezones.timezone.Zulu',
    description: 'Display name for the Zulu timezone',
    defaultMessage: 'Zulu',
  }),
};
